<template>
  <div class="row mt-1" :class="{'no-gutter': isMobile}" style="position: relative">
    <div class="orders-body d-flex">
      <!--      <div class="orders-summary">-->
      <!--        <div class="orders-header">-->
      <!--          Summary-->
      <!--        </div>-->
      <!--        <div class="orders-summary-info">-->
      <!--          <div class="orders-summary-info-item d-flex">-->
      <!--            <div class="orders-summary-info-item-name">Vehicle:</div>-->
      <!--            <div class="orders-summary-info-item-user">{{card.vehicle.make}} {{card.vehicle.model}}</div>-->
      <!--          </div>-->
      <!--          <div class="orders-summary-info-item d-flex">-->
      <!--            <div class="orders-summary-info-item-name">Insurer:</div>-->
      <!--            <div class="orders-summary-info-item-user">{{ card.insurance.insurer_name ? card.insurance.insurer_name : 'Non-Insurance'}}</div>-->
      <!--          </div>-->

      <!--          <div class="orders-summary-using">-->
      <!--            Ordered Using: PARTSSEARCH-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="orders-summary-add-manual-order">-->
      <!--          <button @click="addManual" type="button" class="tab-header-orders btn" style="cursor: pointer">-->
      <!--            Add Manual Order-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="orders-section">
        <div class="orders-header"  :class="{'orders-header-mobile': isMobileOnly}">
          <div class="orders-header-left">
            <span>Orders</span>
            <div class="orders-global-stats"> 
              <span :class="{'orders-global-stats-block-mobile': isMobileOnly}"><span :class="{'orders-global-stats-title-mobile':  isMobileOnly}">Grand Total:</span> <strong>{{ ordersGrandTotal | formatMoney }}</strong></span>
              <span class="orders-profit-text" :class="{'orders-global-stats-block-mobile': isMobileOnly}" ><span :class="{'orders-global-stats-title-mobile':  isMobileOnly}">Profit:</span> {{ ordersGrandProfit | formatMoney }} ({{ ordersGrandProfitPercent }}%)</span>
            </div>
          </div>
          <button type="button" class="orders-outline-btn orders-scan-btn">
            <i class="bx bx-scan"></i>
            Scan Invoice
          </button>
        </div>
        <div class="orders-controls">
          <div class="orders-part-search">
            <i class="bx bx-search"></i>
            <input
                v-model="ordersSearch"
                type="text"
                placeholder="Search parts by name, number, or value..."
            >
          </div>
          <div class="orders-filter-group">
            <button
                type="button"
                class="orders-filter-btn"
                :class="{active: ordersFilter === 'not_ordered'}"
                @click="setOrdersFilter('not_ordered')"
            >To Be Ordered</button>
            <button
                type="button"
                class="orders-filter-btn"
                :class="{active: ordersFilter === 'ordered'}"
                @click="setOrdersFilter('ordered')"
            >To Be Received</button>
            <button
                type="button"
                class="orders-filter-btn"
                :class="{active: ordersFilter === 'return'}"
                @click="setOrdersFilter('return')"
            >Return Items</button>
            <button
                type="button"
                class="orders-filter-btn orders-filter-all"
                :class="{active: ordersFilter === 'all' && !ordersSearch}"
                @click="setOrdersFilter('all')"
            >All Orders</button>
          </div>
        </div>
        <div
            class="orders-section-body"
            :class="{open: isOrderOpen(order.id)}"
            v-for="order in computedOrders"
            :key="order.id"
            v-show="isOrderVisible(order)"
        >
          <div class="orders-section-item">
            <div class="orders-section-item-header d-flex" @click="toggleOrderAccordion(order.id, $event)">
              <div class="orders-section-item-header-info d-flex">
              <div class="orders-section-item-header-elem d-flex">
                <div class="orders-section-item-header-elem_name">Order Number:</div>
                <input v-if="isManual(order) && false" @focus="onFocusOrderDetails(order.id, 'number')" @blur="onBlurOrderDetails(order)" v-model="order.number" :disabled="!isStatusActive" @change="saveOrder(order)" class="form-control"/>
                <div v-else class="orders-section-item-header-elem_info">{{order.number}}</div>
              </div>
              <div class="orders-section-item-header-elem d-flex">
                <div class="orders-section-item-header-elem_name">Type:</div>
                <template v-if="isManual(order)">
                  <multiselect
                      v-if="isEditable[order.id] && isManual(order)"
                      v-model="order.type"
                      :options="optionTypeValues.map((itm) => {return itm.value})"
                      :showLabels="false"
                      :option-height="29"
                      :max-height="203"
                      :close-on-select="true"
                      :disabled="!isStatusActive"
                      @input="saveOrder(order)"
                      openDirection="bottom"
                      style="min-width: 100px; opacity: 1"
                  >
                    <template #singleLabel="{ option }">
                      {{getTypeName(option)}}
                    </template>
                    <template #option="{ option }">
                      {{getTypeName(option)}}
                    </template>
                  </multiselect>
                  <div v-else class="orders-section-item-header-elem_info">{{getTypeName(order.type)}}</div>
                </template>
                <template v-else>
                  <div class="orders-section-item-header-elem_info">Parts</div>
                </template>
                <!--                <input v-if="isManual(order)" @focus="onFocusOrderDetails(order.id, 'type')" @blur="onBlurOrderDetails(order)" v-model="order.type" :disabled="!isStatusActive" @change="saveOrder(order)" class="form-control"/>-->

              </div>
              <div class="orders-section-item-header-elem d-flex">
                <div class="orders-section-item-header-elem_name">Supplier:</div>
                <div >
                  <multiselect
                      v-if="isEditable[order.id] && isManual(order)"
                      v-model="order.supplier"
                      :options="suppliersAll.map((itm) => String(itm.supplier_id))"
                      :showLabels="false"
                      :option-height="29"
                      :max-height="203"
                      :searchable="true"
                      :custom-label="getSupplierName"
                      :close-on-select="true"
                      :disabled="!isStatusActive"
                      openDirection="bottom"
                      class="orders-section-item-header-elem-supplier"
                      style="min-width: 200px; opacity: 1"
                      @input="saveOrder(order)"
                      label="business_name"
                  >
                    <template #singleLabel="{ option }">
                      {{getSupplierName(option)}}
                    </template>
                    <template #option="{ option }">
                      {{getSupplierName(option)}}
                    </template>
                  </multiselect>
                  <!--                  <input v-if="isManual(order)" v-model="order.supplier" @focus="onFocusOrderDetails(order.id, 'supplier')" @blur="onBlurOrderDetails(order)" :disabled="!isStatusActive" @change="saveOrder(order)" class="form-control"/>-->
                  <span v-else class="orders-section-item-header-elem_info">{{order.supplier}}</span>
                </div>
              </div>
              <div class="orders-section-item-header-elem d-flex">
                <div class="orders-section-item-header-elem_name">Order Date:</div>
                <div class="orders-section-item-header-elem_time" style="width: 110px">
                  <date-picker v-if="isEditable[order.id] && isManual(order)" :is-disabled="!isStatusActive" v-model="order.orderDate" @onChange="saveOrder(order)"></date-picker>
                  <span v-else class="orders-section-item-header-elem_info" style="font-weight: 300">
                    <span v-if="order.orderDate == null">Next available run</span>
                    <span v-else-if="order.orderDate">{{formatOrderHeaderDate(order.orderDate)}}</span>
                  </span>
                </div>
              </div>
              <div class="orders-section-item-header-elem d-flex">
                <div class="orders-section-item-header-elem_name">Delivery Date:</div>
                <div class="orders-section-item-header-elem_time" style="width: 110px">
                  <date-picker v-if="isEditable[order.id] && isManual(order)" :is-disabled="!isStatusActive" v-model="order.deliveryDate"  @onChange="saveOrder(order)"></date-picker>
                  <span v-else class="orders-section-item-header-elem_info" style="font-weight: 300">
                    <span v-if="order.deliveryDate == null">Next available run</span>
                    <span v-else-if="order.deliveryDate">{{formatOrderHeaderDate(order.deliveryDate)}}</span>
                  </span>
                </div>
              </div>
              </div>
              <div class="orders-section-item-header-actions">
                <div class="orders-order-stats">
                  <span class="orders-section-item-header-elem_info">Total: {{ getOrderTotal(order) | formatMoney }} ({{ getOrderItems(order).length }} Items)</span>
                  <span class="orders-profit-text">Profit: {{ getOrderProfit(order) | formatMoney }} ({{ getOrderProfitPercent(order) }}%)</span>
                </div>
                <button
                    v-if="!isEditable[order.id]"
                    type="button"
                    class="orders-filter-btn"
                    :class="{'orders-outline-btn-mobile': isMobileOnly}"
                    @click.stop="editSelectedParts(order.id)"
                >
                  <i class="bx bx-edit-alt"></i>
                  <span :class="{'orders-outline-btn-mobile-hide': isMobileOnly}">Edit Order</span>
                </button>
                <button
                    v-else
                    type="button"
                    class="orders-filter-btn active"
                    :class="{'orders-outline-btn-mobile': isMobileOnly}"
                    @click.stop="confirmEditSelectedParts(order.id)"
                >
                 Hide edit
                </button>
                <i class="bx bx-chevron-down orders-accordion-chevron"></i>
              </div>
            </div>
          </div>
           <div class="table-orders" v-show="isOrderOpen(order.id)">
            <div class="orders-table-header d-flex">
              <div :style="{'display': isManual(order) ? 'block' : 'none'}" class="orders-table-header-item" style="padding-top: .60rem; padding-bottom: .60rem">
                <label class="form-check-inline checkbox">
                  <input class="form-check-input" type="checkbox" @click="onCheckedAll(order)" v-model="isCheckedOrderAll[order.id]">
                  <span class="icon checkbox-icon"><i class='bx bx-check'></i></span>
                </label>
              </div>
              <div class="orders-table-header-item orders-table-header-row-part-description" style="min-width: 150px;">
                <span v-if="isManual(order) && order.type !== 'parts'">Description</span>
                <span v-else>Part Description</span>
              </div>
              <div class="orders-table-header-item orders-table-header-row-part-number" style="min-width: 125px;" v-if="(isManual(order) && order.type == 'parts') || !isManual(order)">Part Number</div>
              <div class="orders-table-header-item orders-table-header-row-status">Status</div>
              <div class="orders-table-header-item orders-table-header-row-type-type" v-if="(isManual(order) && order.type == 'parts') || !isManual(order)">Type</div>
              <div class="orders-table-header-item orders-table-header-row-auth">Auth</div>
              <div class="orders-table-header-item orders-table-header-row-qty-ord">Qty Ord</div>
              <div class="orders-table-header-item orders-table-header-row-qty-rcvd">Qty Rcvd</div>
              <div class="orders-table-header-item orders-table-header-row-list" v-if="(isManual(order) && order.type == 'parts') || !isManual(order)">List</div>
              <div class="orders-table-header-item orders-table-header-row-cost-price">Cost Price</div>
              <div class="orders-table-header-item orders-table-header-row-total">Total</div>
              <div class="orders-table-header-item orders-table-header-row-invoice-nbr">Invoice Nbr</div>
              <div class="orders-table-header-item orders-table-header-row-invoice-date">Invoice Date</div>
              <div class="orders-table-header-item orders-table-header-row-icon" style="min-width: 160px; max-width: 160px;"></div>
            </div>
            <div class="orders-table-body">
              <draggable :list="getOrderItems(order)"
                         class="dragArea"
                         tag="div"
                         handle=".handle"
                         @change="saveDraggable(order)"
                         :animation="150"
                         :disabled="isMobile || !isStatusActive || !isManual(order) || !isEditable[order.id]"
                         :group="{ name: 'items-' + order.id, put: false, pull: false }"
                         ghost-class="ghost-items"
              >
                <div
                    v-for="(item, index) in getOrderItems(order)"
                    :key="item.id"
                    v-if="isOrderItemVisible(item, order)"
                    class="handle orders-table-body-row d-flex"
                    :class="{ 'context-active-row': activeContextId === item.id }"
                    @click="clickOnItem($event, order, item)"
                    @contextmenu.prevent="openContextMenu($event, order, item)"
                >
                  <div :style="{'display': isManual(order) ? 'block' : 'none'}" class="orders-table-body-row-icon orders-table-body-row-item">
                    <label class="form-check-inline checkbox order-editable-el">
                      <input class="form-check-input" type="checkbox" v-model="checkedParts[item.id]" @click="onCheckboxChange(order)">
                      <span class="icon checkbox-icon"><i class='bx bx-check'></i></span>
                    </label>
                  </div>
                  <div class="orders-table-body-row-part-description orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <input
                          :ref="'part-description-' + order.id + '-' + index"
                          v-model="item.description"
                          :disabled="!isStatusActive"
                          @keydown.left="onKeyPressLeft('part-description-' + order.id + '-' + index, $event)"
                          @keydown.right="onKeyPressRight('part-description-' + order.id + '-' + index, $event)"
                          @keydown.up="onKeyPressUp('part-description-'  + order.id + '-' + index)"
                          @keydown.down="onKeyPressDown('part-description-' + order.id + '-' + index)"
                          @keydown.tab="onKeyPressRight('part-description-' + order.id + '-' + index, $event)"
                          @keydown.tab.shift="onKeyPressLeft('part-description-' + order.id + '-' + index, $event)"
                          @focus="onFocus('part-description-' + order.id + '-' + index, order.id, 'description', item.id)"
                          @change="saveOrderPart(order.id, item)"
                          @blur="onBlur(item, 'partDescription')"
                          @keypress.enter="onKeyPressEnter(order.id)"
                          class="form-control order-editable-el"/>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.description}}</span>
                      <span> {{ item.partDescription }}</span>
                    </template>
                  </div>
                  <div v-if="(isManual(order) && order.type == 'parts') || !isManual(order)" class="orders-table-body-row-part-number orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <input
                          :ref="'part-number-' + order.id + '-' + index"
                          v-model="item.number"
                          :disabled="!isStatusActive"
                          @keydown.left="onKeyPressLeft('part-number-' + order.id + '-' + index, $event)"
                          @keydown.right="onKeyPressRight('part-number-' + order.id + '-' + index, $event)"
                          @keydown.up="onKeyPressUp('part-number-'+ order.id + '-' + index)"
                          @change="saveOrderPart(order.id, item)"
                          @keydown.down="onKeyPressDown('part-number-'+ order.id + '-' + index)"
                          @keydown.tab="onKeyPressRight('part-number-' + order.id + '-' + index, $event)"
                          @keydown.tab.shift="onKeyPressLeft('part-number-' + order.id + '-' + index, $event)"
                          @focus="onFocus('part-number-' + order.id + '-' + index, order.id, 'number', item.id)"
                          @blur="onBlur(item, 'partNumber')"
                          @keypress.enter="onKeyPressEnter(order.id)"
                          class="form-control order-editable-el"/>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.number}}</span>
                      <span> {{ item.partNumber }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-status orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <multiselect
                          :ref="'status-' + order.id + '-' + index"
                          v-model="item.status"
                          :options="orderItemStatusOptions.map((itm) => itm.value)"
                          :showLabels="false"
                          :option-height="29"
                          :max-height="203"
                          :close-on-select="true"
                          :disabled="!isStatusActive"
                          @onKeyLeft="onKeyPressLeft('status-'+ order.id + '-' + index)"
                          @onKeyRight="onKeyPressRight('status-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('status-'+ order.id + '-' + index, event)"
                          @onKeyTabShift="event => onKeyPressLeft('status-'+ order.id + '-' + index, event)"
                          @input="saveOrderPart(order.id, item)"
                          class="order-editable-el"
                          openDirection="bottom"
                      >
                        <template #singleLabel="{ option }">
                          {{ getOrderItemStatusLabel(option) }}
                        </template>
                        <template #option="{ option }">
                          {{ getOrderItemStatusLabel(option) }}
                        </template>
                      </multiselect>
                    </template>
                    <template v-else>
                      <span>{{ getOrderItemStatusLabel(item.status) }}</span>
                    </template>
                  </div>
                  <div v-if="(isManual(order) && order.type == 'parts') || !isManual(order)" class="orders-table-body-row-type orders-table-body-row-item orders-table-body-row-type-type">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <multiselect
                          :ref="'type-' + order.id + '-' + index"
                          v-model="item.type"
                          :options="optionsPartsType"
                          :showLabels="false"
                          :option-height="29"
                          @onKeyLeft="onKeyPressLeft('type-'+ order.id + '-' + index)"
                          @onKeyRight="onKeyPressRight('type-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('type-'+ order.id + '-' + index, event)"
                          @onKeyTabShift="event => onKeyPressLeft('type-'+ order.id + '-' + index, event)"
                          @keydown.tab.native="onKeyPressRight('type-'+ order.id + '-' + index, $event)"
                          @keydown.tab.shift.native="onKeyPressLeft('type-'+ order.id + '-' + index, $event)"
                          :max-height="heightMultiselect"
                          placeholder="Select option"
                          :close-on-select="true"
                          :disabled="!isStatusActive"
                          style="opacity: 1;"
                          @open="currentOrderId = order.id"
                          @input="saveOrderPart(order.id, item)"
                          class="order-editable-el"
                          openDirection="bottom"
                      >
                      </multiselect>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.type}}</span>
                      <span v-else> {{ item.partsType }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-type orders-table-body-row-item orders-table-body-row-auth">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <label class="form-check-inline checkbox" @click.stop>
                        <input
                            :ref="'auth-' + order.id + '-' + index"
                            class="form-check-input"
                            type="checkbox"
                            :disabled="!isStatusActive"
                            @keydown.left="onKeyPressLeft('auth-'+ order.id + '-' + index)"
                            @keydown.right="onKeyPressRight('auth-'+ order.id + '-' + index)"
                            @keydown.up="onKeyPressUp('auth-'  + order.id + '-' + index)"
                            @keydown.down="onKeyPressDown('auth-' + order.id + '-' + index)"
                            @keydown.tab="onKeyPressRight('auth-' + order.id + '-' + index, $event)"
                            @keydown.tab.shift="onKeyPressLeft('auth-' + order.id + '-' + index, $event)"
                            :checked="isOrderItemAuthChecked(item)"
                            @focus="onFocus('auth-' + order.id + '-' + index, order.id, 'auth', item.id)"
                            @change="toggleOrderItemAuth(order.id, item, $event)"
                            @click.stop
                            @blur="onBlur(item, 'auth', false)"
                        >
                        <span class="order-editable-el icon checkbox-icon" @click.stop><i class='bx bx-check'></i></span>
                      </label>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{ item.auth ? 'Yes' : 'No' }}</span>
                      <span v-else>{{ item.auth ? 'Yes' : 'No' }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-qty-ord orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <number-formatter
                          :ref="'qty-ord-' + order.id + '-' + index"
                          v-model="item.qtyOrdered"
                          :isDisabled="!isStatusActive"
                          type="text"
                          class="form-control order-editable-el"
                          format="0,0"
                          @onKeyRight="event => onKeyPressRight('qty-ord-' + order.id + '-' + index, event.event)"
                          @onKeyLeft="event => onKeyPressLeft('qty-ord-' + order.id + '-' + index, event.event)"
                          @onKeyUp="onKeyPressUp('qty-ord-'+ order.id + '-' + index)"
                          @onKeyDown="onKeyPressDown('qty-ord-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('qty-ord-' + order.id + '-' + index, event.event)"
                          @onKeyShiftTab="event => onKeyPressLeft('qty-ord-' + order.id + '-' + index, event.event)"
                          @blur="onBlur(item, 'qty_ord')"
                          @onFocus="onFocus('qty-ord-' + order.id + '-' + index, order.id, 'qtyOrdered', item.id)"
                          @onChange="saveOrderPart(order.id, item)"
                          @onKeyEnter="onKeyPressEnter(order.id)"
                      >
                      </number-formatter>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.qtyOrdered}}</span>
                      <span> {{ item.qty }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-qty-rcvd orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <number-formatter
                          :ref="'qty-rcvd-' + order.id + '-' + index"
                          v-model="item.qtyReceived"
                          :isDisabled="!isStatusActive"
                          type="text"
                          class="form-control order-editable-el"
                          format="0,0"
                          @onKeyRight="event => onKeyPressRight('qty-rcvd-' + order.id + '-' + index, event.event)"
                          @onKeyLeft="event => onKeyPressLeft('qty-rcvd-' + order.id + '-' + index, event.event)"
                          @onKeyUp="onKeyPressUp('qty-rcvd-'+ order.id + '-' + index)"
                          @onKeyDown="onKeyPressDown('qty-rcvd-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('qty-rcvd-' + order.id + '-' + index, event.event)"
                          @onKeyShiftTab="event => onKeyPressLeft('qty-rcvd-' + order.id + '-' + index, event.event)"
                          @blur="onBlur(item, 'qty_rcvd')"
                          @onChange="saveOrderPart(order.id, item)"
                          @onFocus="onFocus('qty-rcvd-' + order.id + '-' + index, order.id, 'qtyReceived', item.id)"
                          @onKeyEnter="onKeyPressEnter(order.id)"
                      >
                      </number-formatter>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">
                         {{item.qtyReceived }}
                      </span>
                      <span v-else-if="(item.status == 'Arrived' || item.status == 'Received') && item.qtyReceived == null">
                        {{item.qty }}
                      </span>
                      <span v-else>
                         {{ item.qtyReceived }}
                      </span>
                    </template>
                  </div>
                  <div v-if="(isManual(order) && order.type == 'parts') || !isManual(order)" class="orders-table-body-row-list orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <number-formatter
                          :ref="'list-' + order.id + '-' + index"
                          v-model="item.list"
                          :isDisabled="!isStatusActive"
                          class="form-control order-editable-el"
                          type="text"
                          format="$0,0.00"
                          @onKeyRight="event => onKeyPressRight('list-' + order.id + '-' + index, event.event)"
                          @onKeyLeft="event => onKeyPressLeft('list-' + order.id + '-' + index, event.event)"
                          @onKeyUp="onKeyPressUp('list-'+ order.id + '-' + index)"
                          @onKeyDown="onKeyPressDown('list-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('list-' + order.id + '-' + index, event.event)"
                          @onKeyShiftTab="event => onKeyPressLeft('list-' + order.id + '-' + index, event.event)"
                          @blur="onBlur(item, 'list')"
                          @onFocus="onFocus('list-' + order.id + '-' + index, order.id, 'list', item.id)"
                          @onChange="saveOrderPart(order.id, item)"
                          @onKeyEnter="onKeyPressEnter(order.id)"
                      >
                      </number-formatter>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.list | formatMoney}}</span>
                      <span v-else> {{item.rrp | formatMoney }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-cost-price orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <number-formatter
                          :ref="'cost-price-' + order.id + '-' + index"
                          v-model="item.cost"
                          class="form-control order-editable-el"
                          :isDisabled="!isStatusActive"
                          type="text"
                          format="$0,0.00"
                          @onKeyRight="event => onKeyPressRight('cost-price-' + order.id + '-' + index, event.event)"
                          @onKeyLeft="event => onKeyPressLeft('cost-price-' + order.id + '-' + index, event.event)"
                          @onKeyUp="onKeyPressUp('cost-price-'+ order.id + '-' + index)"
                          @onKeyDown="onKeyPressDown('cost-price-'+ order.id + '-' + index)"
                          @onKeyTab="event => onKeyPressRight('cost-price-' + order.id + '-' + index, event.event)"
                          @onKeyShiftTab="event => onKeyPressLeft('cost-price-' + order.id + '-' + index, event.event)"
                          @onChange="saveOrderPart(order.id, item)"
                          @blur="onBlur(item, 'cost_price')"
                          @onFocus="onFocus('cost-price-' + order.id + '-' + index, order.id, 'cost', item.id)"
                          @onKeyEnter="onKeyPressEnter(order.id)"
                      >
                      </number-formatter>
                    </template>
                    <template v-else>
                      <span v-if="isManual(order)">{{item.cost | formatMoney}}</span>
                      <span v-else> {{item.price | formatMoney }}</span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-total orders-table-body-row-item">
                    <span>{{ getItemTotal(item) | formatMoney }}</span>
                  </div>
                  <div class="orders-table-body-row-invoice-nbr orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <input
                          :ref="'invoice-nbr-' + order.id + '-' + index"
                          v-model="item.invoiceNumber"
                          :disabled="!isStatusActive"
                          @keydown.left="onKeyPressLeft('invoice-nbr-' + order.id + '-' + index, $event)"
                          @keydown.right="onKeyPressRight('invoice-nbr-' + order.id + '-' + index, $event)"
                          @keydown.up="onKeyPressUp('invoice-nbr-'+ order.id + '-' + index)"
                          @keydown.down="onKeyPressDown('invoice-nbr-'+ order.id + '-' + index)"
                          @keydown.tab="onKeyPressRight('invoice-nbr-' + order.id + '-' + index, $event)"
                          @keydown.tab.shift="onKeyPressLeft('invoice-nbr-' + order.id + '-' + index, $event)"
                          @focus="onFocus('invoice-nbr-' + order.id + '-' + index, order.id, 'invoiceNumber', item.id)"
                          @blur="onBlur(item, 'invoice_nbr')"
                          @keypress.enter="onKeyPressEnter(order.id)"
                          @change="saveOrderPart(order.id, item)"
                          class="form-control order-editable-el"/>
                    </template>
                    <template v-else>
                      {{ item.invoiceNumber }}
                    </template>
                  </div>
                  <div class="orders-table-body-row-invoice-nbr orders-table-body-row-item">
                    <template v-if="isManual(order) && isEditable[order.id]">
                      <date-picker
                          v-model="item.invoiceDate"
                          @onChange="saveOrderPart(order.id, item)"
                          place-holder-text="Date"
                          :ref="'invoice-date-' + order.id + '-' + index"
                          :disabled="!isStatusActive"
                          class="order-editable-el"
                          @onKeyPressLeft="onKeyPressLeft('invoice-date-' + order.id + '-' + index, $event)"
                          @onKeyPressRight="onKeyPressRight('invoice-date-' + order.id + '-' + index, $event)"
                          @onKeyPressUp="onKeyPressUp('invoice-date-'+ order.id + '-' + index)"
                          @onKeyPressDown="onKeyPressDown('invoice-date-'+ order.id + '-' + index)"
                          @onKeyPressTab="onKeyPressRight('invoice-date-' + order.id + '-' + index, $event)"
                          @onKeyPressTabShift="onKeyPressLeft('invoice-date-' + order.id + '-' + index, $event)"
                      ></date-picker>
                    </template>
                    <template v-else>
                      <span v-if="item.invoiceDate">
                         {{ item.invoiceDate | formatDate}}
                      </span>
                    </template>
                  </div>
                  <div class="orders-table-body-row-icon orders-table-body-row-item" @click.stop>
                    <div>
                      <!-- Icon 1 - Parts delivery status -->
                      <i
                         :class="getDeliveryStatusIcon(item, order).icon"
                         :style="{color: getDeliveryStatusIcon(item, order).color}"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip orders-icons-tooltip', title: getDeliveryStatusIcon(item, order).tooltip, placement: 'bottomleft'}"></i>

                      <!-- Icon 2 - Credit status -->
                      <i
                         :class="getCreditStatusIcon(item, order).icon"
                         :style="{color: getCreditStatusIcon(item, order).color}"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip orders-icons-tooltip', title: getCreditStatusIcon(item, order).tooltip, placement: 'bottomleft'}"></i>

                      <!-- Icon 3 - PartsSearch order deep link -->
                      <i class="part-ps-logo" :style="{opacity: getPartsSearchLinkIcon(order).url ? 1 : 0.35}"
                         @click="redirectToPSOrder(order.partssearchOrderId)"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip orders-icons-tooltip', title: getPartsSearchLinkIcon(order).tooltip, placement: 'bottomleft'}"></i>
                      <!-- Icon 4 - Xero/MYOB accounting state -->
                      <span>
                        <i class='xero'
                           :style="{color: getXeroBillIcon(order).color}"
                           @click="openXeroBillUrl(getXeroBillIcon(order).url)"
                           v-b-tooltip.hover="{customClass: 'ps-tooltip orders-icons-tooltip', title: getXeroBillIcon(order).tooltip, placement: 'bottomleft'}">
                        <svg width="21px" height="21px" viewBox="0 0 173 173" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="xero-central-logo-primary-version" transform="translate(0.400200, 0.063150)">
                              <g id="Group" :fill="getXeroBillIcon(order).color">
                                <path d="M76.2749267,72.0220466 C70.0066029,72.0359078 64.5511632,76.3118471 63.0401878,82.3953517 L89.5231871,82.3953517 C88.0169312,76.3031147 82.5506065,72.0230166 76.2749267,72.0220466 L76.2749267,72.0220466 Z" id="Path"></path>
                                <path d="M133.779753,71.8872707 C128.246077,71.8330105 123.226905,75.1242618 121.070881,80.2209342 C118.914857,85.3176067 120.048423,91.211625 123.941144,95.1449738 C127.833865,99.0783227 133.715796,100.273022 138.834579,98.1700299 C143.953361,96.067038 147.296547,91.0823078 147.299828,85.5483671 C147.326105,78.0476676 141.280322,71.9387853 133.779753,71.8872707 L133.779753,71.8872707 Z M133.779753,90.5104106 C131.769227,90.5276186 129.947074,89.3297749 129.165687,87.477224 C128.3843,85.6246731 128.798172,83.4836965 130.213697,82.055831 C131.629222,80.6279656 133.766526,80.195525 135.625789,80.9608027 C137.485053,81.7260803 138.698668,83.5377676 138.698924,85.5483671 C138.70502,88.2746363 136.505972,90.4928552 133.779753,90.5104106 L133.779753,90.5104106 Z" id="Shape"></path>
                                <path d="M85.9989507,-1.35700789e-14 C38.5020139,-1.35700789e-14 2.71401578e-14,38.5060722 2.71401578e-14,86.003009 C2.71401578e-14,133.499946 38.5052605,172.002771 86.0021973,172.002771 C133.499134,172.002771 172.002771,133.498322 172.002771,86.0013857 C172.002771,63.19168 162.942888,41.3159569 146.813762,25.1872876 C130.684636,9.05861835 108.808656,-1.35700789e-14 85.9989507,-1.35700789e-14 Z M54.8215499,105.197089 C54.0535499,105.190193 53.3219635,104.868715 52.7974761,104.307658 L38.3703419,89.7671855 L23.8804605,104.375924 C23.0763756,105.17599 21.868663,105.411109 20.8231631,104.971124 C19.7776632,104.531138 19.1014887,103.503209 19.1113157,102.368944 C19.1092285,101.603428 19.4214434,100.870584 19.9750433,100.341862 L34.4102943,85.747905 L19.9534051,71.171929 C19.4154294,70.6386052 19.1123863,69.9127377 19.1113157,69.1552081 C19.1006811,68.0208091 19.7766531,66.992424 20.8222954,66.552414 C21.8679378,66.112404 23.0758211,66.3480561 23.879391,67.1488383 L38.3843981,81.726409 L52.832082,67.1761201 C53.3540361,66.6378168 54.0717647,66.3335269 54.821569,66.3335269 C56.3753979,66.3392294 57.6315585,67.60137 57.6298979,69.1552081 C57.6338291,69.8986348 57.3383251,70.6123669 56.8099577,71.1353655 L42.3634102,85.7594116 L56.8110845,100.380641 C57.6117466,101.188758 57.8500004,102.398077 57.4156959,103.449501 C56.9813915,104.500926 55.9591544,105.189582 54.8215881,105.197089 L54.8215499,105.197089 Z M94.3337915,86.1085074 C93.220148,87.387233 91.5941045,88.1024817 89.8989726,88.0592537 L62.8276059,88.0642096 C62.8319889,88.1334597 62.8368207,88.2039415 62.8389215,88.2715205 C62.9772867,89.0065147 63.1681723,89.7306424 63.4101102,90.4383341 C65.3958031,95.8874962 70.5575623,99.529816 76.3570775,99.574172 C78.5684392,99.5618672 80.7425974,99.0040835 82.6867614,97.9502817 C84.0888369,97.1599349 85.3466628,96.1374434 86.406697,94.9263319 C86.7246818,94.5574218 87.0010039,94.1858474 87.2681303,93.8262763 L87.3314408,93.7411747 C87.8459637,92.9605707 88.7091391,92.4802766 89.6437062,92.454568 C90.2996142,92.4656292 90.933394,92.6935955 91.4460691,93.1028656 C92.0256615,93.560637 92.3951641,94.2336146 92.470324,94.9683479 C92.5702102,95.8416879 92.3184599,96.7188783 91.7706332,97.4063272 L91.6624515,97.5192452 C90.2925516,99.3472468 88.630695,100.936935 86.7437132,102.22438 C84.9613448,103.369273 83.0009707,104.209754 80.9428295,104.711422 C79.415171,105.119223 77.8409048,105.326318 76.2597532,105.327482 C75.5035097,105.326433 74.7480045,105.280196 73.9972767,105.18902 C66.0537204,104.143707 59.5472903,98.3666455 57.5692921,90.6026071 C57.1822341,89.0612266 56.9869834,87.4779506 56.9879312,85.8887159 C56.9751045,79.5490074 60.0097297,73.5893722 65.1442829,69.8707121 C71.5438538,65.3156309 80.0634034,65.0857117 86.6993385,69.2890004 C91.1903782,72.1801115 94.290999,76.7946974 95.2705004,82.0452724 C95.5747399,83.4715611 95.2317611,84.9593573 94.3338106,86.1085074 L94.3337915,86.1085074 Z M111.913063,72.2180132 C106.342608,72.9130822 105.788866,75.6250344 105.788866,82.1122306 L105.788866,102.13543 C105.797564,103.137482 105.268035,104.067181 104.401722,104.570853 C103.535409,105.074524 102.465483,105.074742 101.598965,104.571424 C100.732447,104.068105 100.202539,103.138622 100.210829,102.136566 L100.201581,69.5786626 C100.191861,68.2015636 101.190076,67.0240937 102.550208,66.8083648 C103.91034,66.5926359 105.223912,67.4034359 105.640721,68.7159784 C107.547113,67.3092151 109.856412,66.554879 112.225633,66.5649061 L113.016737,66.5764656 C114.572042,66.5831743 115.828721,67.8470111 115.826599,69.4023291 C115.82217,70.1448299 115.520236,70.8545578 114.988366,71.3726719 C114.456497,71.8907861 113.739104,72.1740255 112.996742,72.1589998 C112.634715,72.1588811 112.272954,72.1785817 111.913082,72.2180132 L111.913063,72.2180132 Z M133.779762,105.01896 C125.887281,105.090897 118.731913,100.391779 115.661917,93.1204963 C112.591921,85.8492133 114.214518,77.4439661 119.770434,71.8378779 C125.326351,66.2317898 133.716672,64.5336997 141.015259,67.5382062 C148.313846,70.5427127 153.077098,77.6555487 153.076208,85.5483576 C153.109196,96.2474047 144.478665,104.955867 133.779753,105.01896 L133.779762,105.01896 Z" id="Shape"></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </i>
                      </span>

                      <!-- Icon 5 - Supplier bill PDF -->
                      <i
                         :class="'bx ' + getBillPdfIcon(item, order).icon"
                         :style="{color: getBillPdfIcon(item, order).color}"
                         @click="getBillPdfIcon(item, order).url ? openBillPdfUrl(getBillPdfIcon(item, order).url) : openUploadBillModal(order.id, item.id)"
                         v-b-tooltip.hover="{customClass: 'ps-tooltip orders-icons-tooltip', title: getBillPdfIcon(item, order).tooltip, placement: 'bottomleft'}"></i>

                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="orders-add-part-row" v-if="isManual(order) && isOrderOpen(order.id) && isEditable[order.id]">
            <button @click="onKeyPressEnter(order.id)" type="button" class="tab-header-orders btn" style="cursor: pointer; margin-left: 34px;">
              Add Manual Part
            </button>
          </div>
        </div>
      </div>
      <vue-context ref="ordersContext"  @close="contextClose" :close-on-click="false">
        <ul slot-scope="scope">
          <!-- Блок Invoice Nbr -->
          <li class="hasSubContextOrders" v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length">
            Add Invoice Nbr
            <i class="icon-right bx bx-chevron-right"></i>
            <ul class="orders-sub-context">
              <input
                  v-model="invoiceNbr"
                  class="orders-input-context"
                  @keyup.enter.prevent="selectedInvNumber(scope.data.selectedParts)"
                  type="text">
              <div class="order-context-invoice-nbr">Invoice Number</div>
            </ul>
          </li>

          <!-- Блок Invoice Date -->
          <li class="hasSubContextOrders" v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length">
            Add Invoice Date
            <i class="icon-right bx bx-chevron-right"></i>
            <ul class="orders-sub-context" style="height: 80px; overflow: visible">
              <date-picker
                  v-model="invoiceDate"
                  class="datepicker-position-absolute"
                  @input="selectedInvDate(scope.data.selectedParts)"
                  style="top: 10px; right: 20px; transform: translateX(10px);"
                  :is-disabled="!isStatusActive">
              </date-picker>
              <div style="margin-top: 45px" class="order-context-invoice-nbr">Invoice Date</div>
            </ul>
          </li>

          <!-- Редактирование заказа -->
          <li v-if="scope.data && scope.data.order && !isEditable[scope.data.order.id]"
              @click="editSelectedParts(scope.data.order.id)">
            Edit Order
          </li>

          <!-- Delete Items -->
          <li v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length"
              @click="deleteItems(scope.data.selectedParts)">
            Delete Items
          </li>

          <!-- Прочие действия -->
          <li v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length && canReceiveSelectedItems(scope.data.selectedParts)"
              @click="receiveItems(scope.data.selectedParts)">
            Receive Items
          </li>
          <li v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length"
              @click="returnItems(scope.data.selectedParts)">
            Return Items
          </li>
          <li v-if="scope.data && scope.data.selectedParts && scope.data.selectedParts.length"
              @click="backorderItems(scope.data.order, scope.data.selectedParts)">
            Backorder Items
          </li>
          <li v-if="scope.data && scope.data.order && scope.data.selectedParts && scope.data.selectedParts.length && canCancelSelectedItems(scope.data.selectedParts)"
              @click="cancelItems(scope.data.order, scope.data.selectedParts)">
            Cancel Items
          </li>
        </ul>
      </vue-context>
      <modal-wizard class="upload-bill-modal" ref="uploadBillModal" :hideFinishButton="true" :hide-cancel-button="true">
        <modal-wizard-tab title="Upload Bill">
          <div style="margin-bottom: 0px !important; margin-top:5px">
            Upload a copy of the supplier invoice
          </div>

          <vue-dropzone
              v-on:vdropzone-removed-file="removeFileDropzone"
              v-on:vdropzone-file-added="addFileUpload"
              v-on:vdropzone-complete="completeFileUpload"
              v-on:vdropzone-sending="sendFileUpload"
              v-on:vdropzone-success="successFileUpload"
              ref="fileUpDrop"
              id="fileUploadDrop"
              class="dropify-wrapper dropzoneContainer"
              style="height: auto; border: none; min-height: auto; margin: 0 !important; padding: 0px 0px 25px 0; background-color: white !important; background-image: none; background-size: 0px;"
              :options="fileUploadDropzoneOptions"
              :useCustomSlot=true>
            <div class="dropify-message"
                 style="transform: translateY(0%); background-color: white">
              <div class="text-sm-center mb-1 ex-image-upload-buttons d-flex justify-content-between" style="align-items: center">
                <div class="" style="margin: 0 !important; position: relative">
                  <button type="button"
                          style="width: 170px"
                          @click="isShowScanner = !isShowScanner"
                          class="btn btn-primary waves-effect waves-light">
                    Select Scanner
                  </button>
                  <div v-if="isShowScanner" class="scanner-items">
                    <template v-if="activePcs && activePcs.length">
                      <div
                          v-for="pc in activePcs"
                          :key="pc.id"
                          @click="isShowScanner = false; $emit('selectPc', pc)"
                          class="scanner-item"
                          :class="{'selected-scanner-item': pc.id == selectedPcId}"
                      >
                        {{pc.pc_name}}
                      </div>
                    </template>
                    <template v-else>
                      <div class="scanner-item">No Active Scanners</div>
                    </template>
                  </div>
                  <div class="current-scanner" v-else-if="selectedPcId">
                    Current Scanner: {{selectedPcName}}
                  </div>
                </div>
                <button type="button"
                        class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files">
                  Browse Files
                </button>
                <button @click="$refs.uploadBillModal.hide()" type="button"
                        class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                </button>
              </div>
            </div>

          </vue-dropzone>

          <!--          <button-->
          <!--              id="browseModalWizardButton"-->
          <!--              ref="browseModalWizardButton"-->
          <!--              v-if="tabTitle == 'Upload Bill'"-->
          <!--              @keyup.left="leftKeyPressed"-->
          <!--              @keyup.right="rightKeyPressed"-->
          <!--              type="button"-->
          <!--              class="btn btn-next btn-paid-min-size mr-1"-->
          <!--              :class="{-->
          <!--                                    'btn-primary': activeButton === 'finish',-->
          <!--                                    'btn-secondary': activeButton !== 'finish'-->
          <!--                                }"-->
          <!--              :disabled="loading"-->
          <!--          >-->
          <!--            {{ browseButtonText }}-->
          <!--          </button>-->
        </modal-wizard-tab>
      </modal-wizard>
    </div>
    <div v-if="selectedBillFile" class="orders-pdf-viewer-overlay">
      <pdf-viewer
          :documentHeight="billPdfDocumentHeight"
          :documentPath="selectedBillFile.url"
          @closePdf="selectedBillFile = null"
      ></pdf-viewer>
    </div>
  </div>
</template>

<script>
import NumberFormatter from '../../utility/number-formatter'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import datePicker from '@/components/utility/date-picker.vue'
import vue2Dropzone from 'vue2-dropzone'
const rsMsMixin = {
  mounted() {
    const searchInput = this.$refs.search;
    if (searchInput) {
      searchInput.addEventListener('keydown', this.handleKeydown);
    }
    if (this.$el) {
      this.$el.addEventListener('keydown', this.handleKeydown);
    }
  },
  beforeDestroy() {
    const searchInput = this.$refs.search;
    if (searchInput) {
      searchInput.removeEventListener('keydown', this.handleKeydown);
    }
    if (this.$el) {
      this.$el.removeEventListener('keydown', this.handleKeydown);
    }
  },
  methods: {
    handleKeydown(e) {
      if (e.keyCode === 37) {
        e.preventDefault();
        this.$emit('onKeyLeft');
        //   e.stopPropagation();

      } else if (e.keyCode === 39) {
        e.preventDefault();
        this.$emit('onKeyRight');
        //  e.stopPropagation();

      } else if (e.keyCode === 13) {
        var vm = this;
        setTimeout(() => {
          vm.$emit('onKeyRight');
        }, 50);
      } else if (e.keyCode === 9) {
        e.preventDefault();
        if (e.shiftKey) {
          this.$emit('onKeyTabShift', e);
        } else {
          this.$emit('onKeyTab', e);
        }
      }
    }
  }
};

Multiselect.mixins.push(rsMsMixin);

import {isMobile, isMobileOnly} from '../../../deviceDetect/index'
import {mapGetters} from "vuex";
import _ from "lodash";
import {appConfig} from "../../../config";
import dayjs from "dayjs";
import Axios from "axios";
import {VueContext} from "vue-context";
import PdfViewer from '../../utility/pdf-viewer'
import { AUTO_SAVE_STATUS } from '@/constants/autoSaveStatus'

export default {
  name: "the-orders",
  props: {
    suppliersAll: {
      type: Array,
      default () {
        return []
      }
    },
    activePcs: {
      type: Array,
      default () {
        return []
      }
    },
    selectedPcId: {
      type: [Object, Number, String],
      default () {
        return null
      }
    },
    selectedPcName: {
      type: [Object, Number, String],
      default () {
        return null
      }
    },
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    orders: {
      type: Array,
      default () {
        return []
      }
    },
    estimateId: {
      type: [Number, String],
      default () {
        return 0
      }
    },
    suppliers: {
      type: Object,
      default () {
        return {}
      }
    },
    parts: {
      type: Array,
      default () {
        return []
      }
    },
  },
  created() {
    this.loadSuppliers()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.checkShift)
    window.removeEventListener('keyup', this.removeShift)
  },
  mounted() {
    window.addEventListener('keydown', this.checkShift)
    window.addEventListener('keyup', this.removeShift)
  },
  components: {
    Multiselect,
    NumberFormatter,
    datePicker,
    draggable,
    vueDropzone: vue2Dropzone,
    VueContext,
    PdfViewer
  },
  data() {
    return {
      activeContextId: null,
      heightMultiselect: 0,
      isMobile,
      isMobileOnly,
      optionTypeValues: [
        {name: 'Parts', value: 'parts'},
        {name: 'Consumables', value: 'consumables'},
        {name: 'Mechanical', value: 'mechanical'},
        {name: 'PDR', value: 'pdr'},
        {name: 'Ancilary Services', value: 'ancillary'},],
      orderItemStatusOptions: [
        { value: 'ordered', label: 'ORDERED' },
        { value: 'received', label: 'RECEIVED' },
        { value: 'backorder', label: 'BACK ORDER' },
        { value: 'cancelled', label: 'CANCELLED' }
      ],
      selectedBillFile: null,
      billPdfDocumentHeight: 600,
      currentOrderId: null,
      currentItemId: null,
      invoiceNbr: '',
      invoiceDate: '',
      isHoldShift: false,
      isShowScanner: false,
      fileUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        url: appConfig.baseAPIURL + '/fe/card/uploadFilesDropzone',
        method: 'post',
        maxFilesize: 50,
        timeout: 300000,
        clickable: '.browse-btn-files',
        // maxFiles: 2,     //Can be used to limit the maximum number of files that will be handled by this Dropzone
        thumbnailWidth: 200,
        addRemoveLinks: false,
        acceptedFiles: 'application/pdf, .doc, .docx',
        dictFileTooBig: 'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again',
      },
      checkedParts: {},
      isCheckedOrderAll: {},
      isEditable: {},
      openOrderIds: {},
      ordersFilter: 'all',
      ordersSearch: '',
      editableParts: [],
      manualOrdersData: [],
      manualOrdersDataOriginal: [],
      suppliersForSelect: [],
      focusedElement: '',
      focusedElementDetailes: null,
      focusedOrderDetailes: null,
      pendingNewOrderItemFocus: null,
      optionsPartsType: ['None', 'OEM-GEN', 'OEM-PAR', 'OEM-ALT', 'CERT-AFTM', 'AFTM', 'USED', 'RECO',],
    }
  },
  computed: {
    ...mapGetters({
      isStatusActive: 'isStatusActive',
    }),
    computedAvailableRefs () {
      let order = _.find(this.computedOrders, (o) => {return Number(o.id) == Number(this.currentOrderId)})
      let result = []
      if (order) {
        _.forEach(order.items || [], (part, index) => {
          let cells = ['part-description-' + this.currentOrderId + '-' + index, 'part-number-' + this.currentOrderId + '-' + index, 'status-' + this.currentOrderId + '-' + index, 'type-' + this.currentOrderId + '-' + index, 'qty-ord-' + this.currentOrderId + '-' + index, 'qty-rcvd-' + this.currentOrderId + '-' + index,
            'list-' + this.currentOrderId + '-' + index, 'cost-price-' + this.currentOrderId + '-' + index, 'total-' + this.currentOrderId + '-' + index,
            'invoice-nbr-' + this.currentOrderId + '-' + index,  'invoice-date-' + this.currentOrderId + '-' + index,
          ]
          if (this.isManual(order) && order.type !== 'parts') {
            cells = _.filter(cells, (c) => {
              return !_.includes(c, 'list-') && !_.includes(c, 'part-number-') && !_.includes(c, 'type-')
            })
          }
          result.push(cells)
        })
      }
      return result
    },
    computedOrders() {
      let manualOrders = _.filter(this.manualOrdersData, (order) => {
        return order.source === 'manual'
      })

      return _.orderBy(manualOrders, [(itm) => new Date(itm.createdOn).getTime()],['desc']);
    },
    ordersGrandTotal() {
      return _.sumBy(this.computedOrders, (order) => this.getOrderTotal(order))
    },
    ordersGrandProfit() {
      return _.sumBy(this.computedOrders, (order) => this.getOrderProfit(order))
    },
    ordersGrandProfitPercent() {
      const totalCost = _.sumBy(this.computedOrders, (order) => this.getOrderCost(order))
      if (!totalCost) {
        return 0
      }
      return ((this.ordersGrandProfit / totalCost) * 100).toFixed(0)
    },
    computedSuppliers() {
      let r = [];
      _.forIn(this.suppliers, (itm) => {
        r.push(itm)
      })

      return r
    }
  },
  watch: {
    orders: {
      handler(v) {
        // Filter only manual orders from unified orders array
        let manualOrders = _.filter(v, (order) => {
          return order.source === 'manual'
        })

        let result = _.cloneDeep(manualOrders)
        this.manualOrdersDataOriginal = _.cloneDeep(manualOrders)
        _.forEach(result, (o) => {
          if (o.deliveryDate) {
            o.deliveryDate = this.formatOrderHeaderDate(o.deliveryDate);
          }
          if (o.orderDate) {
            o.orderDate = this.formatOrderHeaderDate(o.orderDate);
          }
        })

        if (this.focusedElementDetailes || this.focusedOrderDetailes) {
          let r = []
          _.forEach(result, (order) => {
            if (this.focusedElementDetailes) {
              if (Number(order.id) == Number(this.focusedElementDetailes.orderId)) {
                let o = _.cloneDeep(order)
                let prtIndex = _.findIndex(o.items, (itm) => {
                  return Number(itm.id) == Number(this.focusedElementDetailes.prtId)
                })
                let orderOrigin = _.findIndex(this.manualOrdersData, (itm) => {
                  return Number(itm.id) == Number(this.focusedElementDetailes.orderId)
                })

                if (orderOrigin !== -1 && prtIndex !== -1 ) {
                  let prtIndexOrigin = _.findIndex(this.manualOrdersData[orderOrigin].items || [], (itm) => {
                    return Number(itm.id) == Number(this.focusedElementDetailes.prtId)
                  })
                  if (prtIndexOrigin !== -1) {
                    o.items[prtIndex][this.focusedElementDetailes.field] = this.manualOrdersData[orderOrigin].items[prtIndexOrigin][this.focusedElementDetailes.field]
                    r.push(o)
                  } else {
                    r.push(order)
                  }
                } else {
                  r.push(order)
                }
              } else {
                r.push(order)
              }
            } else {
              let field = this.focusedOrderDetailes.field
              if (Number(order.id) == Number(this.focusedOrderDetailes.orderId)) {
                let orderOrigin = _.find(this.manualOrdersData, (itm) => {
                  return Number(itm.id) == Number(this.focusedOrderDetailes.orderId)
                })
                if (orderOrigin) {
                  let o = _.cloneDeep(order)
                  o[field] = orderOrigin[field]
                  r.push(o)
                } else {
                  r.push(order)
                }
              } else {
                r.push(order)
              }
            }
          })
          this.manualOrdersData = r
        } else {
          this.manualOrdersData = result
        }
        this.focusPendingNewOrderItemDescription()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getOrderItems(order) {
      return this.isManual(order) ? (order.items || []) : (order.parts || [])
    },
    parseOrderMoney(value) {
      if (value === null || value === undefined || value === '') {
        return 0
      }
      const result = Number(String(value).replace(/[^0-9.-]+/g, ''))
      return Number.isNaN(result) ? 0 : result
    },
    getItemCost(item) {
      return this.parseOrderMoney(item.cost !== undefined ? item.cost : item.price)
    },
    getItemList(item) {
      return this.parseOrderMoney(item.list !== undefined ? item.list : item.rrp)
    },
    getItemTotal(item) {
      if (['cancelled', 'canceled'].includes(this.normalizeOrderItemStatusValue(item))) {
        return 0
      }

      const qtyOrdered = this.parseOrderMoney(item.qtyOrdered !== undefined ? item.qtyOrdered : item.qty)
      return this.getItemCost(item) * qtyOrdered
    },
    getOrderTotal(order) {
      return _.sumBy(this.getOrderItems(order), (item) => this.getItemTotal(item))
    },
    getOrderList(order) {
      return _.sumBy(this.getOrderItems(order), (item) => this.getItemList(item))
    },
    getOrderCost(order) {
      return _.sumBy(this.getOrderItems(order), (item) => this.getItemCost(item))
    },
    getOrderProfit(order) {
      return _.sumBy(this.getOrderItems(order), (item) => this.getItemList(item) - this.getItemCost(item))
    },
    getOrderProfitPercent(order) {
      const list = this.getOrderList(order)
      if (!list) {
        return 0
      }
      return ((this.getOrderProfit(order) / list) * 100).toFixed(2)
    },
    normalizeOrderFilterStatus(value) {
      return String(value || '').replace(/_/g, ' ').toUpperCase()
    },
    normalizeOrderItemStatusValue(item) {
      return String(item?.status || item?.deliveryStatus || '').toLowerCase().replace(/[_\s]+/g, '_')
    },
    canReceiveSelectedItems(parts) {
      return _.some(parts, (item) => this.normalizeOrderItemStatusValue(item) !== 'received')
    },
    canCancelSelectedItems(parts) {
      return _.some(parts, (item) => !['cancelled', 'canceled'].includes(this.normalizeOrderItemStatusValue(item)))
    },
    isOrderItemAuthChecked(item) {
      return !!(item && item.auth)
    },
    toggleOrderItemAuth(orderId, item, event) {
      this.$set(item, 'auth', event.target.checked)
      this.saveOrderPart(orderId, item)
    },
    isOrderMatchedBySearch(order) {
      const search = String(this.ordersSearch || '').trim().toLowerCase()
      if (!search) {
        return false
      }
      const searchValue = [
        order.number,
        this.getTypeName(order.type),
        order.type,
        order.supplier,
        order.orderDate,
        order.deliveryDate
      ].join(' ').toLowerCase()
      return searchValue.includes(search)
    },
    isOrderItemVisible(item, order = null) {
      if (order && this.isOrderMatchedBySearch(order)) {
        return true
      }
      const search = String(this.ordersSearch || '').trim().toLowerCase()
      const searchValue = [
        item.description,
        item.partDescription,
        item.number,
        item.partNumber,
        item.invoiceNumber
      ].join(' ').toLowerCase()
      const status = this.normalizeOrderItemStatusValue(item)

      if (search && !searchValue.includes(search)) {
        return false
      }
      if (this.ordersFilter === 'not_ordered') {
        return status === 'ordered'
      }
      if (this.ordersFilter === 'ordered') {
        return ['ordered', 'backorder', 'back_order'].includes(status)
      }
      if (this.ordersFilter === 'return') {
        return item.isReturned === true || item.isReturned === 1 || item.isReturned === '1' || ['return', 'returned'].includes(status)
      }
      return true
    },
    normalizeOrderHeaderDateForState(value) {
      if (!value) {
        return value
      }

      const parsedDate = this.parseOrderHeaderDate(value)

      return parsedDate ? parsedDate.format('YYYY-MM-DD') : value
    },
    formatOrderHeaderDate(value) {
      if (!value) {
        return value
      }

      const parsedDate = this.parseOrderHeaderDate(value)

      return parsedDate ? parsedDate.format('DD/MM/YYYY') : value
    },
    parseOrderHeaderDate(value) {
      if (!value) {
        return null
      }

      if (value instanceof Date) {
        const parsedDate = dayjs(value)
        return parsedDate.isValid() ? parsedDate : null
      }

      if (typeof value === 'string') {
        const isoMatch = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
        if (isoMatch) {
          const parsedDate = dayjs(`${isoMatch[1]}-${isoMatch[2].padStart(2, '0')}-${isoMatch[3].padStart(2, '0')}`)
          return parsedDate.isValid() ? parsedDate : null
        }

        const slashMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        if (slashMatch) {
          const first = Number(slashMatch[1])
          const second = Number(slashMatch[2])
          const year = slashMatch[3]
          const day = first <= 12 && second > 12 ? second : first
          const month = first <= 12 && second > 12 ? first : second
          const parsedDate = dayjs(`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`)

          return parsedDate.isValid() && parsedDate.date() === day && parsedDate.month() + 1 === month ? parsedDate : null
        }
      }

      const parsedDate = dayjs(value)

      return parsedDate.isValid() ? parsedDate : null
    },
    syncOrderHeaderState(order) {
      const syncOrder = (orders) => {
        const orderState = _.find(orders, (item) => Number(item.id) === Number(order.id))
        if (!orderState) {
          return
        }

        this.$set(orderState, 'number', order.number)
        this.$set(orderState, 'type', order.type)
        this.$set(orderState, 'supplier', order.supplier)
        this.$set(orderState, 'deliveryDate', this.normalizeOrderHeaderDateForState(order.deliveryDate))
        this.$set(orderState, 'orderDate', this.normalizeOrderHeaderDateForState(order.orderDate))
      }

      syncOrder(this.orders)
      syncOrder(this.manualOrdersDataOriginal)
    },
    isOrderVisible(order) {
      if (this.isOrderMatchedBySearch(order)) {
        return true
      }
      const items = this.getOrderItems(order)
      if (items.length === 0) {
        return !this.ordersSearch && this.ordersFilter === 'all'
      }
      return _.some(items, (item) => this.isOrderItemVisible(item, order))
    },
    isOrderOpen(id) {
      return this.openOrderIds[id] !== false
    },
    toggleOrderAccordion(id, event) {
      if (event && event.target && event.target.closest('input, button, textarea, select, .multiselect, .order-editable-el')) {
        return
      }
      this.$set(this.openOrderIds, id, !this.isOrderOpen(id))
    },
    setOrdersFilter(filter) {
      if (filter !== 'all' && this.ordersFilter === filter) {
        this.ordersFilter = 'all'
        _.forEach(this.computedOrders, (order) => {
          this.$set(this.openOrderIds, order.id, true)
        })
        return
      }
      this.ordersFilter = filter
      if (filter === 'all') {
        this.ordersSearch = ''
        const shouldOpenAll = _.some(this.computedOrders, (order) => {
          return !this.isOrderOpen(order.id)
        })
        _.forEach(this.computedOrders, (order) => {
          this.$set(this.openOrderIds, order.id, shouldOpenAll)
        })
        return
      }
      _.forEach(this.computedOrders, (order) => {
        this.$set(this.openOrderIds, order.id, true)
      })
    },
    // Icon 1 - Parts delivery status
    getDeliveryStatusIcon(item, order) {
      const defaultIcon = { icon: 'bx bx-package', color: '#9e9e9e', tooltip: 'Not ordered' }
      if (!item || !item.deliveryStatus) return defaultIcon
      const status = item.deliveryStatus
      const icons = {
        ordered: { icon: 'bx bx-package', color: '#5e79ff', tooltip: 'Ordered' },
        on_delivery: { icon: 'bx bxs-truck', color: '#5e79ff', tooltip: 'On delivery' },
        arrived: { icon: 'bx bx-buildings', color: '#28a745', tooltip: 'Arrived' },
        received: { icon: 'bx bx-buildings', color: '#28a745', tooltip: 'Received' },
        returned: { icon: 'bx bx-undo', color: '#bd5008', tooltip: 'Returned' },
        return: { icon: 'bx bx-undo', color: '#bd5008', tooltip: 'Returned' }
      }
      return icons[status] || defaultIcon
    },
    // Icon 2 - Credit approval/denial
    getCreditStatusIcon(item, order) {
      const defaultIcon = { icon: 'bx bx-dollar-circle', color: '#9e9e9e', tooltip: 'Credit unavailable' }
      if (!item || !item.creditStatus || item.creditStatus === 'none') return defaultIcon
      const status = item.creditStatus
      const icons = {
        approved: { icon: 'bx bx-dollar-circle', color: '#28a745', tooltip: 'Credit approved' },
        denied: { icon: 'bx bx-dollar-circle', color: '#dc3545', tooltip: 'Credit denied' }
      }
      return icons[status] || defaultIcon
    },
    // Icon 3 - PartsSearch order deep link
    getPartsSearchLinkIcon(order) {
      if (!order || !order.partssearchOrderUrl) {
        return { icon: 'part-ps-logo', color: '#9e9e9e', tooltip: 'PartsSearch link unavailable', url: null }
      }
      return { icon: 'part-ps-logo', color: '#00a0df', tooltip: 'Open in PartsSearch', url: order.partssearchOrderUrl }
    },
    // Icon 4 - Xero/MYOB accounting state
    getXeroBillIcon(order) {
      const defaultIcon = { icon: 'xero', color: '#9e9e9e', tooltip: 'Bill not sent', url: null }
      if (!order) return defaultIcon

      const hasXeroBill = !!order.xeroBillUrl || !!order.xeroBillId || !!order.iconStates?.hasXeroBill
      if (!hasXeroBill || order.xeroBillStatus === 'not_available') return defaultIcon

      const hasUrl = !!order.xeroBillUrl
      const color = hasUrl ? '#13B5EA' : '#9e9e9e'
      const tooltip = hasUrl ? 'Open in Xero' : 'Xero bill sent, link unavailable'
      return { icon: 'xero', color: color, tooltip: tooltip, url: order.xeroBillUrl || null }
    },
    // Icon 5 - Supplier bill PDF
    getBillPdfIcon(item, order) {
      if (!item || !order) {
        return { icon: 'bxs-file-pdf', color: '#9e9e9e', tooltip: 'Bill unavailable', url: null }
      }
      if (item.billFileId) {
        return { icon: 'bxs-file-pdf', color: '#bd5008', tooltip: 'View Bill', url: item?.billFile?.url }
      }
      return { icon: 'bxs-file-pdf', color: '#9e9e9e', tooltip: 'Upload Bill to Files', url: null }
    },
    openXeroBillUrl(url) {
      if (!url) return

      const popup = window.open('', '_blank')
      if (popup) {
        popup.location.href = url
      }
    },
    openBillPdfUrl(url) {
      this.billPdfDocumentHeight = window.innerHeight - 160
      console.log('openBillPdfUrl',url)
      this.selectedBillFile = { url: url, isPdf: true }
    },
    openUploadBillModal(orderId, itemId) {
      this.currentOrderId = orderId
      this.currentItemId = itemId
      this.$refs.uploadBillModal.show()
    },
    checkShift(e) {
      if (e.which == 16) {
        this.isHoldShift = true
      }
    },
    removeShift() {
      this.isHoldShift = false
    },
    isHeightMultiselect(){
      if(window.innerWidth < 1586) {
        console.log(window.innerWidth)
        this.heightMultiselect = 80
      }
      else {
        this.heightMultiselect = 203
      }
    },
    removeFileDropzone ($event) {
      let filesReplace = []

      this.files.forEach((file) => {
        if (!file.uuid) {
          filesReplace.push(file)
        } else if (file.uuid && file.uuid !== $event.upload.uuid) {
          filesReplace.push(file)
        }
      })
      this.files = filesReplace
    },
    addFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    completeFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    sendFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
      let reader = new FileReader()
      reader.onload = (e) => {
        let fileBase60Code = e.target.result
        this.$emit('addFile', {
          name: $event.name,
          src: fileBase60Code,
          user: this.$store.state.userInfo.first_name + ' ' + this.$store.state.userInfo.last_name,
          date: '',
          uuid: $event.upload.uuid
        })
      }
      reader.readAsDataURL($event)
    },
    successFileUpload (file, response) {
      if (response.status) {
        var vm = this
        const fileId = response.file_id

        // Step 2: Send billFileId to server via item update
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
        Axios.post('/fe/estimate/orders/items/' + this.currentItemId + '/update', {
          billFileId: fileId
        }).then((response) => {
          // Update local state with full item including billFile
          const order = this.orders.find(o => o.id === this.currentOrderId)
          if (order) {
            const item = order.items.find(i => i.id === this.currentItemId)
            if (item && response.data.item) {
              this.$set(item, 'billFileId', response.data.item.billFileId)
              this.$set(item, 'billFile', response.data.item.billFile)
            }
          }

          this.$emit('addFiles', {file: file, id: fileId})
          setTimeout(function () {
            vm.$refs.fileUpDrop.removeFile(file)
            vm.$refs.uploadBillModal.hide()
            vm.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
          }, 1000)
        }).catch(() => {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        })
      }
    },
    clickCancelDropzoneFiles: function () {
      this.$refs.fileUpDrop.removeAllFiles(true)
      this.file_ids = []
    },
    selectedInvDate(parts) {
      const itemIds = _.map(parts, 'id')
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/invoice-date', {
        itemIds: itemIds,
        invoiceDate: this.invoiceDate
      }).then(() => {
        _.forEach(parts, (p) => {
          this.$set(p, 'invoiceDate', this.invoiceDate)
        })
        this.invoiceDate = ''
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    selectedInvNumber(parts) {
      const itemIds = _.map(parts, 'id')
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/invoice-number', {
        itemIds: itemIds,
        invoiceNumber: this.invoiceNbr
      }).then(() => {
        _.forEach(parts, (p) => {
          this.$set(p, 'invoiceNumber', this.invoiceNbr)
        })
        this.invoiceNbr = ''
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    cancelItems(order, parts) {
      const itemIds = _.map(parts, 'id')
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/cancel', {
        itemIds: itemIds,
        reason: 'Cancelled from orders tab'
      }).then(() => {
        _.forEach(parts, (p) => {
          this.$set(p, 'qtyReceived', 0)
          this.$set(p, 'status', 'cancelled')
          this.$set(p, 'deliveryStatus', 'cancelled')
        })
        if (order.items.length == parts.length) {
          this.removeOrder(order.id)
        } else {
          _.forEach(parts, (p) => {
            this.deleteOrderPart(order.id, p.id)
          })
        }
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    deleteItems(parts) {
      const itemIds = _.map(parts, 'id')
      const confirmed = confirm(`Are you sure you want to delete ${itemIds.length} item(s)?`)
      if (!confirmed) return

      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/delete', {
        itemIds: itemIds
      }).then((r) => {
        if (r.data && r.data._status) {
          this.removeOrderItemsFromState(itemIds)
          this.$refs.ordersContext.close()
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        } else {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        }
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    backorderItems(order, parts) {
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      const requests = _.map(parts, (part) => {
        this.$set(part, 'status', 'backorder')
        this.$set(part, 'deliveryStatus', 'backorder')

        return Axios.post(`/fe/estimate/orders/items/${part.id}/update`, {
          description: part.description,
          number: part.number,
          type: part.type,
          qtyOrdered: part.qtyOrdered,
          qtyReceived: part.qtyReceived,
          cost: part.cost,
          list: part.list,
          invoiceNumber: part.invoiceNumber,
          invoiceDate: part.invoiceDate,
          status: part.status,
          deliveryStatus: part.deliveryStatus,
          creditStatus: part.creditStatus,
          auth: part.auth
        })
      })

      Promise.all(requests).then(() => {
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    receiveItems(parts) {
      const itemIds = _.map(parts, 'id')
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/receive', {
        itemIds: itemIds
      }).then(() => {
        _.forEach(parts, (p) => {
          const status = String(p.status || p.deliveryStatus || '').toLowerCase().replace(/[_\s]+/g, '_')
          if (['ordered', 'cancelled', 'backorder', 'back_order'].includes(status)) {
            this.$set(p, 'qtyReceived', p.qtyOrdered)
            this.$set(p, 'status', 'received')
            this.$set(p, 'deliveryStatus', 'received')
          }
        })
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    returnItems(parts) {
      const reason = prompt('Please enter return reason:')
      if (!reason) return

      const itemIds = _.map(parts, 'id')
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/return', {
        itemIds: itemIds,
        reason: reason
      }).then(() => {
        _.forEach(parts, (p) => {
          this.$set(p, 'status', 'received')
          this.$set(p, 'deliveryStatus', 'received')
          this.$set(p, 'isReturned', 1)
          this.$set(p, 'returnedAt', new Date().toISOString())
          this.$set(p, 'returnReason', reason)
        })
        this.$refs.ordersContext.close()
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    editSelectedParts(id) {
      this.editOrder(id)
      this.$refs.ordersContext.close()
      this.isHeightMultiselect()
    },
    confirmEditSelectedParts(id) {
      this.confirmEditOrder(id)
      this.$refs.ordersContext.close()
    },
    onCheckedAll(order) {
      setTimeout(() => {
        this.$nextTick(() => {
          console.log(order, this.isCheckedOrderAll[order.id], this.isCheckedOrderAll)
          _.forEach(this.isManual(order) ? order.items : order.parts, (part) => {
            this.$set(this.checkedParts, part.id, this.isCheckedOrderAll[order.id])
            // this.checkedParts[part.id] = this.isCheckedOrderAll[order.id]
          })
        })
      }, 0)
    },
    onCheckboxChange(order) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$set(this.isCheckedOrderAll, order.id, !_.some(this.isManual(order) ? order.items : order.parts, (p) => {
            return !this.checkedParts[p.id]
          }))
        })
      }, 0)
    },
    clickOnItem(e, order, part) {
      if (!this.isManual(order)) {
        return
      }
      if (e) {
        let targets = document.elementsFromPoint(e.clientX, e.clientY)
        let isClickedOnEditableEl = _.some(targets, (t) => {
          return _.includes(t?.classList, 'order-editable-el')
        })
        if (isClickedOnEditableEl) {
          return;
        }
      }
      setTimeout(() => {
        let isCheckedByShift = false
        this.$nextTick(() => {
          console.log(this.isHoldShift, this.lastCheckedPart, 'is hold, last check')
          if (e && this.isHoldShift && this.lastCheckedPart) {
            let lastOrder = _.find(this.computedOrders, (o) => {
              return _.find(o.items || [], (itm) => {
                return Number(itm.id) == Number(part.id)
              })
            })
            console.log(lastOrder, 'last order', lastOrder?.id, order?.id)
            if (lastOrder && Number(lastOrder.id) == Number(order.id)) {
              let min = Number(this.lastCheckedPart) < Number(part.id) ? Number(this.lastCheckedPart) : Number(part.id)
              let max = Number(this.lastCheckedPart) > Number(part.id) ? Number(this.lastCheckedPart) : Number(part.id)

              console.log(min, max, 'min max')

              _.forEach(order.items || [], (p) => {
                if (Number(p.id) >= min && Number(p.id) <= max) {
                  this.$set(this.checkedParts, p.id, true)
                }
              })
              isCheckedByShift = true
            }
          }
          this.lastCheckedPart = (part.id, e ? !this.checkedParts[part.id] : true) ? part.id : null
          if (!isCheckedByShift) {
            this.$set(this.checkedParts, part.id, e ? !this.checkedParts[part.id] : true)
          }
          this.onCheckboxChange(order)
        })
      }, 0)
    },
    openContextMenu(e, order, part) {
      e.preventDefault();
      this.activeContextId = part.id; // Устанавливаем активный ID

      // Collect selected parts for this order
      let selectedParts = [];
      _.forEach(this.isManual(order) ? order.items : order.parts, (p) => {
        if (this.checkedParts[p.id]) {
          selectedParts.push(p);
        }
      });

      // If no parts are selected, default to the clicked part
      if (selectedParts.length === 0) {
        selectedParts = [part];
      }

      // If only one part is selected, pre-fill invoice fields
      if (selectedParts.length === 1) {
        this.invoiceNbr = selectedParts[0].invoiceNumber || ''
        this.invoiceDate = selectedParts[0].invoiceDate || ''
      } else {
        this.invoiceNbr = ''
        this.invoiceDate = ''
      }

      this.$nextTick(() => {
        if (this.$refs.ordersContext) {
          this.$refs.ordersContext.open(e, {
            order: order,
            part: part,
            selectedParts: selectedParts
          });
        }
      });
    },
    contextClose() {
      this.activeContextId = null
    },
    editOrder(id) {
      this.$nextTick(() => {
        // Convert supplier name string to supplier_id for multiselect
        const order = this.orders.find(o => o.id === id)
        if (order && order.supplier && typeof order.supplier === 'string') {
          const supplierObj = _.find(this.suppliersAll, (s) => s.business_name === order.supplier)
          if (supplierObj) {
            this.$set(order, 'supplier', String(supplierObj.supplier_id))
          }
        }
        this.$set(this.isEditable, id, true)
      })
    },
    confirmEditOrder(id) {
      this.$nextTick(() => {
        // Convert supplier_id back to business_name string when exiting edit mode
        const order = this.orders.find(o => o.id === id)
        if (order && order.supplier && typeof order.supplier !== 'object') {
          const supplierObj = _.find(this.suppliersAll, (s) => Number(s.supplier_id) == Number(order.supplier))
          if (supplierObj) {
            this.$set(order, 'supplier', supplierObj.business_name)
          }
        }
        this.$set(this.isEditable, id, false)
      })
    },
    editPart(v) {
      if (!_.includes(this.editableParts, v)) {
        this.editableParts.push(v)
      }
    },
    confirmEditPart(v) {
      if (_.includes(this.editableParts, v)) {
        this.editableParts.splice(this.editableParts.indexOf(v), 1)
      }
    },
    isEditPart(v) {
      return _.includes(this.editableParts, v)
    },
    getSupplierName(v) {
      if (v == null || v === '') return ''
      return _.find(this.suppliersAll, (itm) => {
        return Number(itm.supplier_id) == Number(v)
      })?.business_name || ''
    },
    getTypeName(v) {
      return _.find(this.optionTypeValues, (itm) => {
        return itm.value == v
      })?.name || ''
    },
    getOrderItemStatusLabel(v) {
      return _.find(this.orderItemStatusOptions, (itm) => itm.value === v)?.label || 'ORDERED'
    },
    loadSuppliers: function () {
      Axios.get('/fe/supplier', {
        params: {
          pageNum: 1,
          sort_by: 'supplier_id',
          sort_type: 'DESC'
        }
      })
          .then(response => {
            this.suppliersForSelect = response.data.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    removeOrder(id) {
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/delete', {orderId: id}).then(r => {
        if (r.data._status) {
          this.$emit('removeOrder', id)
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        } else {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        }
      }).catch(() => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
      })
    },
    removePrt(orderId, prt, index) {
      this.deleteOrderPart(orderId, prt.id)
    },
    saveOrder(order) {
      let orderOriginal = _.find(this.manualOrdersDataOriginal, (o) => {
        return Number(o.id) == Number(order.id)
      })
      if (orderOriginal) {
        let b = false
        if ((!orderOriginal.deliveryDate && order.deliveryDate) || (orderOriginal.deliveryDate && dayjs(new Date(orderOriginal.deliveryDate).getTime()).format('YYYY-MM-DD').split('-').reverse().join('/') != order.deliveryDate)) {
          b = true
        }

        if ((!orderOriginal.orderDate && order.orderDate) || (orderOriginal.orderDate && dayjs(new Date(orderOriginal.orderDate).getTime()).format('YYYY-MM-DD').split('-').reverse().join('/') != order.orderDate)) {
          b = true
        }

        if ((!orderOriginal.number && order.number) || (orderOriginal.number && orderOriginal.number != order.number)) {
          b = true
        }
        if ((!orderOriginal.type && order.type) || (orderOriginal.type && orderOriginal.type != order.type)) {
          b = true
        }
        // Compare supplier values (handle both string and object, protect against null)
        const currentSupplier = (order.supplier && typeof order.supplier === 'object') ? order.supplier.business_name : order.supplier
        const originalSupplier = (orderOriginal.supplier && typeof orderOriginal.supplier === 'object') ? orderOriginal.supplier.business_name : orderOriginal.supplier
        if ((!originalSupplier && currentSupplier) || (originalSupplier && originalSupplier != currentSupplier)) {
          b = true
        }
        if (!b) {
          return
        }
      }
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      // Convert supplier_id back to business_name string for API
      let supplierValue = order.supplier
      if (order.supplier && typeof order.supplier !== 'object') {
        const supplierObj = _.find(this.suppliersAll, (s) => Number(s.supplier_id) == Number(order.supplier))
        if (supplierObj) {
          supplierValue = supplierObj.business_name
        }
      }
      this.syncOrderHeaderState(order)
      Axios.post(`/fe/estimate/orders/${order.id}/update`, {
        number: order.number,
        type: order.type,
        supplier: supplierValue,
        deliveryDate: this.normalizeOrderHeaderDateForState(order.deliveryDate),
        orderDate: this.normalizeOrderHeaderDateForState(order.orderDate),
      }).then((r) => {
        this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        // Keep supplier as supplier_id while in edit mode
      })
          .catch(() => {
            this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
          })
    },
    saveOrderPart(orderId, part) {
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post(`/fe/estimate/orders/items/${part.id}/update`, {
        "description": part.description,
        "number": part.number,
        "type": part.type,
        "qtyOrdered": part.qtyOrdered,
        "qtyReceived": part.qtyReceived,
        "cost": part.cost,
        "list": part.list,
        "invoiceNumber": part.invoiceNumber,
        "invoiceDate": part.invoiceDate,
        "totalManual": part.totalManual,
        "status": part.status || 'ordered',
        "deliveryStatus": part.deliveryStatus || 'ordered',
        "creditStatus": part.creditStatus || 'none',
        "auth": !!part.auth
      }).then((r) => {
        if (r.data && r.data._status && r.data.item) {
          this.applyOrderItemResponse(orderId, part, r.data.item)
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        } else {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        }
      })
          .catch(() => {
            this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
          })
    },
    applyOrderItemResponse(orderId, part, responseItem) {
      _.forEach(responseItem, (value, key) => {
        this.$set(part, key, value)
      })

      const syncItem = (orders) => {
        const order = _.find(orders, (o) => Number(o.id) === Number(orderId))
        if (!order || !order.items) {
          return
        }
        const item = _.find(order.items, (i) => Number(i.id) === Number(responseItem.id))
        if (!item) {
          return
        }
        _.forEach(responseItem, (value, key) => {
          this.$set(item, key, value)
        })
      }

      syncItem(this.orders)
      syncItem(this.manualOrdersData)
      syncItem(this.manualOrdersDataOriginal)
    },
    removeOrderItemsFromState(itemIds) {
      const normalizedItemIds = _.map(itemIds, (id) => Number(id))
      const removeItems = (orders) => {
        _.forEach(orders, (order) => {
          if (!order || !order.items) {
            return
          }
          const items = _.filter(order.items, (item) => {
            return !_.includes(normalizedItemIds, Number(item.id))
          })
          this.$set(order, 'items', items)
        })
      }

      removeItems(this.orders)
      removeItems(this.manualOrdersData)
      removeItems(this.manualOrdersDataOriginal)
      _.forEach(normalizedItemIds, (id) => {
        this.$delete(this.checkedParts, id)
      })
    },
    deleteOrderPart(orderId, prtId) {
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post('/fe/estimate/orders/items/delete', {itemIds: [prtId]}).then(r => {
        if (r.data._status) {
          this.removeOrderItemsFromState([prtId])
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        } else {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        }
      })
          .catch(() => {
            this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
          })
    },
    isManual(order) {
      return !!_.find(this.manualOrdersData, (o) => {
        return Number(o.id) == Number(order.id)
      })
    },
    addManual(type) {
      this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVING)
      Axios.post(`/fe/estimate/${this.estimateId}/orders/add`, {
        type: type,
        source: 'manual',
        supplierType: 'manual',
        status: 'draft'
      }).then((r) => {
        if (r.data._status && r.data.order) {
          this.$emit('addManual', r.data.order)
          this.editOrder(r.data.order.id)
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.SAVED)
        } else {
          this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
        }
      })
          .catch(() => {
            this.$emit('autoSaveMessageUpdate', AUTO_SAVE_STATUS.UNSAVED)
          })
    },
    getColorForPricingIcon(prt) {
      let color = '#c6c6c6'
      let origPart = _.find(this.parts, (p) => {
        return Number(p.id) == Number(prt.repairshopPartId)
      })

      if (origPart) {
        if (Number(origPart.total) > Number(prt.total)) {
          color = 'red'
        } else if (Number(origPart.total) < Number(prt.total)) {
          color = 'green'
        }
      }
      return color
    },
    getTextForPricingIcon(prt) {
      let text = ''
      let origPart = _.find(this.parts, (p) => {
        return Number(p.id) == Number(prt.repairshopPartId)
      })

      if (origPart) {
        if (Number(origPart.total) > Number(prt.total)) {
          text = 'Pricing decrease received'
        } else if (Number(origPart.total) < Number(prt.total)) {
          text = 'Pricing increase received'
        }
      }

      return text
    },
    redirectToPSOrder(id) {
      let url = appConfig.appPartsSearchURL + '/r/order/' + id;
      //empty line
      (async (url) => {
        const popup = window.open('', '_blank')
        if (popup) {
          popup.location.href = url
          setTimeout(() => {
            popup.focus()
          }, 1000)
        }
      })(url)
    },
    statusList (order) {
      let result = [
        {
          id: 'Created',
          name: 'Order Processed',
          nameClass: 'text-success',
          color: 'info',
          iconClass: 'bx bx-package mr-0',
          tooltip: 'Ordered'
        },
        {
          id: 'Shipped',
          name: 'Shipped',
          nameClass: 'text-primary',
          color: 'warning',
          iconClass: 'bx bxs-truck text-primary'
        },
        {
          id: 'Received',
          name: 'Received',
          nameClass: 'text-success',
          color: 'success',
          iconClass: 'bx bx-buildings',
          tooltip: 'Received'
        },
        {
          id: 'Arrived',
          name: 'Arrived',
          nameClass: 'text-success',
          color: 'success',
          iconClass: 'bx bx-buildings',
          tooltip: 'Arrived'
        },
        {
          id: 'DamagedPartExWarehouse',
          name: 'Damage Ex Warehouse',
          nameClass: 'text-secondary',
          color: 'danger',
          iconClass: 'bx bxs-factory text-warning',
          tooltip: 'Damaged Part Ex Warehouse'
        },
        {
          id: 'IncorrectPartDelivered',
          name: 'Incorrect Part Delivered',
          nameClass: 'text-danger',
          color: 'bg-warning',
          iconClass: 'bx bxs-flag-alt text-warning',
          tooltip: 'Incorrect'
        },
        {
          id: 'IncorrectPartOrdered',
          name: 'Incorrect Part Ordered',
          nameClass: 'text-danger',
          color: 'bg-warning',
          iconClass: 'bx bxs-flag-alt incorrect-part-ordered-icon',
          tooltip: 'Incorrect Ordered'
        },

        {
          id: 'CancelPart',
          name: 'Cancelled',
          nameClass: 'cancel-part-class',
          color: 'danger',
          iconClass: 'bx bxs-flag-alt text-danger',
          tooltip: 'Cancelled'
        },
        {
          id: 'NoLongerNeeded',
          name: 'No Longer Needed',
          nameClass: 'text-warning',
          color: 'danger',
          iconClass: 'bx bxs-flag-alt text-warning',
          tooltip: 'No Longer Needed'
        },
        {
          id: 'ChangeInRepairMethod',
          name: 'Change in Repair Method',
          nameClass: 'text-warning',
          color: 'danger',
          iconClass: 'bx bxs-flag-alt text-warning',
          tooltip: 'Change in Repair Method'
        },
        {
          id: 'ReturnDamagedPart',
          name: 'Returned',
          nameClass: 'text-secondary',
          color: 'danger',
          iconClass: 'bx font-24 bx-transfer-alt text-warning',
          tooltip: 'Returned'
        },
        {
          id: 'DamagedPartExWarehouse',
          name: 'Mark Damaged Part Ex Warehouse',
          nameClass: 'text-secondary',
          color: 'danger',
          iconClass: 'bx bxs-factory text-warning',
          tooltip: 'Damaged Part Ex Warehouse'
        },
        {
          id: 'IncorrectPartDelivered',
          name: 'Incorrect Part',
          nameClass: 'text-danger',
          color: 'bg-warning',
          iconClass: 'bx bxs-flag-alt text-warning',
          tooltip: 'Incorrect'
        },
        {
          id: 'IncorrectPartOrdered',
          name: 'Incorrect Part Ordered',
          nameClass: 'text-danger',
          color: 'bg-warning',
          iconClass: 'bx bxs-flag-alt incorrect-part-ordered-icon',
          tooltip: 'Incorrect Ordered'
        },
        {
          id: 'DidNotArrive',
          name: 'Did Not Arrive',
          nameClass: 'text-danger',
          color: 'danger',
          iconClass: 'bx bxs-flag-alt text-danger'
        },
      ]
      if (order.status !== 'Processing') {
        result = _.filter(result, (r) => {
          return r.id !== 'Created'
        })
      }
      return result
    },
    getIconClass: function (item, order) {
      let status = item.status
      let elem = _.find(this.statusList(order), { id: status })
      if (elem) {
        return elem.iconClass
      }
      return ''
    },
    getNameIcon: function (item, order) {
      let status = item.status
      let elem = _.find(this.statusList(order), { id: status })
      if (elem) {
        return elem.name
      }
      return ''
    },
    getSupplier(sId) {
      if (this.suppliers?.[sId]?.businessName) {
        return this.suppliers[sId].businessName
      }
      return ''
    },
    onKeyPressUp (ref) {
      console.log('up', ref)
      let indexOfCurrentRow = _.findIndex(this.computedAvailableRefs, (row) => {
        return row.includes(ref)
      })
      let indexOfCurrentElement = _.findIndex(this.computedAvailableRefs[indexOfCurrentRow], (r) => {
        return r === ref
      })
      let resultRef = null
      if (indexOfCurrentRow === 0) {
        resultRef = this.computedAvailableRefs[this.computedAvailableRefs.length - 1][indexOfCurrentElement]
      } else {
        resultRef = this.computedAvailableRefs[indexOfCurrentRow - 1][indexOfCurrentElement]
      }
      if (!this.$refs[resultRef]) {
        this.onKeyPressUp(resultRef)
        return
      }
      if (resultRef.includes('status-') || resultRef.includes('type-') || resultRef.includes('auth-')) {
        this.$refs[resultRef][0].$el.focus()
        return;
      }
      if (this.$refs[resultRef][0]) {
        this.$refs[resultRef][0].focus()
      } else {
        this.$refs[resultRef].focus()
      }
    },
    onKeyPressDown (ref) {
      console.log('down')
      let indexOfCurrentRow = _.findIndex(this.computedAvailableRefs, (row) => {
        return row.includes(ref)
      })
      let indexOfCurrentElement = _.findIndex(this.computedAvailableRefs[indexOfCurrentRow], (r) => {
        return r === ref
      })
      let resultRef = null
      if (indexOfCurrentRow + 1 === this.computedAvailableRefs.length) {
        resultRef = this.computedAvailableRefs[0][indexOfCurrentElement]
      } else {
        resultRef = this.computedAvailableRefs[indexOfCurrentRow + 1][indexOfCurrentElement]
      }
      if (!this.$refs[resultRef]) {
        this.onKeyPressDown(resultRef)
        return
      }
      if (resultRef.includes('status-') || resultRef.includes('type-') || resultRef.includes('auth-')) {
        this.$refs[resultRef][0].$el.focus()
        return;
      }
      if (this.$refs[resultRef][0]) {
        this.$refs[resultRef][0].focus()
      } else {
        this.$refs[resultRef].focus()
      }
    },
    onKeyPressLeft (ref, e,) {
      if (e && (e.key === 'Tab' || e.keyCode === 9)) {
        e.preventDefault()
      }
      if (e && e.key !== 'Tab' && e.keyCode !== 9) {
        var elem = e.srcElement
        if (this.getCaretPosition(elem) > 0) {
          return
        }
      }
      let indexOfCurrentRow = _.findIndex(this.computedAvailableRefs, (row) => {
        return row.includes(ref)
      })
      let indexOfCurrentElement = _.findIndex(this.computedAvailableRefs[indexOfCurrentRow], (r) => {
        return r === ref
      })
      let resultRef = null
      if (indexOfCurrentElement === 0) {
        let resultRow = []
        if (indexOfCurrentRow === 0) {
          resultRow = this.computedAvailableRefs[this.computedAvailableRefs.length - 1]
        } else {
          resultRow = this.computedAvailableRefs[indexOfCurrentRow - 1]
        }
        let resultRowLastIndex = resultRow.length - 1
        resultRef = resultRow[resultRowLastIndex]
        if (!this.$refs[resultRef]) {
          this.onKeyPressLeft(resultRef)
          return
        }
      } else {
        resultRef = this.computedAvailableRefs[indexOfCurrentRow][indexOfCurrentElement - 1]
        if (!this.$refs[resultRef]) {
          this.onKeyPressLeft(resultRef)
          return
        }
      }
      if (resultRef.includes('status-') || resultRef.includes('type-') || resultRef.includes('auth-')) {
        this.$refs[resultRef][0].$el.focus()
        return;
      }
      if (this.$refs[resultRef]?.$el) {
        this.$refs[resultRef].$el.focus()
      } else if (this.$refs[resultRef][0]) {
        this.$refs[resultRef][0].focus()
      } else {
        this.$refs[resultRef].focus()
      }
    },
    onKeyPressRight (ref, e) {
      if (e && (e.key === 'Tab' || e.keyCode === 9)) {
        e.preventDefault()
      }
      if (e && e.key !== 'Tab' && e.keyCode !== 9) {
        var elem = e.srcElement
        if (this.getCaretPosition(elem) < elem.value.length) {
          return false
        }
      }
      let indexOfCurrentRow = _.findIndex(this.computedAvailableRefs, (row) => {
        return row.includes(ref)
      })
      let indexOfCurrentElement = _.findIndex(this.computedAvailableRefs[indexOfCurrentRow], (r) => {
        return r === ref
      })
      let resultRef = null

      // Skip Auth column when pressing Tab from Type column
      if (ref.includes('type-') && (e && (e.key === 'Tab' || e.keyCode === 9))) {
        // Find qty-ord in the same row
        const qtyOrdRef = this.computedAvailableRefs[indexOfCurrentRow].find(r => r.includes('qty-ord-'))
        if (qtyOrdRef && this.$refs[qtyOrdRef]) {
          resultRef = qtyOrdRef
        } else {
          // Fallback to normal behavior
          if (indexOfCurrentElement === this.computedAvailableRefs[indexOfCurrentRow].length - 1) {
            if (indexOfCurrentRow === this.computedAvailableRefs.length - 1) {
              resultRef = this.computedAvailableRefs[0][0]
            } else {
              resultRef = this.computedAvailableRefs[indexOfCurrentRow + 1][0]
            }
          } else {
            resultRef = this.computedAvailableRefs[indexOfCurrentRow][indexOfCurrentElement + 1]
          }
        }
      } else if (indexOfCurrentElement === this.computedAvailableRefs[indexOfCurrentRow].length - 1) {
        if (indexOfCurrentRow === this.computedAvailableRefs.length - 1) {
          resultRef = this.computedAvailableRefs[0][0]
        } else {
          resultRef = this.computedAvailableRefs[indexOfCurrentRow + 1][0]
        }

        if (!this.$refs[resultRef]) {
          this.onKeyPressRight(resultRef)
          return
        }
      } else {
        resultRef = this.computedAvailableRefs[indexOfCurrentRow][indexOfCurrentElement + 1]
        if (!this.$refs[resultRef]) {
          this.onKeyPressRight(resultRef)
          return
        }
      }

      if (resultRef.includes('status-') || resultRef.includes('type-') || resultRef.includes('auth-')) {
        this.$refs[resultRef][0].$el.focus()
        return
      }
      if (resultRef.includes('invoice-date-')) {
        this.$refs[resultRef][0].focus()
        return
      }
      if (this.$refs[resultRef]?.$el) {
        this.$refs[resultRef].$el.focus()
      } else if (this.$refs[resultRef][0]) {
        this.$refs[resultRef][0].focus()
      } else {
        this.$refs[resultRef].focus()
      }
    },
    getCaretPosition: function (ctrl) {
      // IE < 9 Support
      if (document.selection) {
        ctrl.focus()
        var range = document.selection.createRange()
        var rangelen = range.text.length
        range.moveStart('character', -ctrl.value.length)
        var start = range.text.length - rangelen
        return start
      }
      // IE >=9 and other browsers
      else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
        return ctrl.selectionEnd
      } else {
        return 0
      }
    },
    onKeyPressEnter(id) {
      const order = _.find(this.computedOrders, (o) => Number(o.id) === Number(id))
      const newItemIndex = order && order.items ? order.items.length : 0
      this.pendingNewOrderItemFocus = {
        orderId: id,
        itemIndex: newItemIndex
      }
      this.editOrder(id)
      this.$emit('addPart', id)
      this.focusPendingNewOrderItemDescription()
    },
    focusPendingNewOrderItemDescription() {
      if (!this.pendingNewOrderItemFocus) {
        return
      }
      const orderId = this.pendingNewOrderItemFocus.orderId
      const itemIndex = this.pendingNewOrderItemFocus.itemIndex
      const focusInput = () => {
        this.$nextTick(() => {
          const refName = 'part-description-' + orderId + '-' + itemIndex
          const descriptionInput = this.$refs[refName] && this.$refs[refName][0]
          if (descriptionInput) {
            descriptionInput.focus()
            setTimeout(() => {
              this.pendingNewOrderItemFocus = null
            }, 500)
          }
        })
      }
      setTimeout(focusInput, 0)
      setTimeout(focusInput, 100)
      setTimeout(focusInput, 300)
    },
    saveDraggable(order) {
      if (!order || !this.isManual(order) || !this.isEditable[order.id] || !order.items) {
        return
      }
      let sort = _.map(order.items, (prt, index) => {
        return {id: prt.id, index: index}
      })
      console.log(sort,)
    },
    onFocusOrderDetails(id, field) {
      this.focusedOrderDetailes = {
        orderId: id,
        field: field,
      }
    },
    onBlurOrderDetails(order) {
      if (this.focusedOrderDetailes && Number(order.id) == Number(this.focusedOrderDetailes.orderId)) {
        let originalOrder = _.find(this.manualOrdersDataOriginal, (o) => {
          return Number(o.id) == Number(order.id)
        })
        let field = this.focusedOrderDetailes.field
        if (originalOrder && originalOrder[field] !== order[field]) {
          this.saveOrder(order)
        }
      }

      this.focusedOrderDetailes = null
    },
    onFocus (ref, id, field, prtId) {
      this.currentOrderId = id
      this.focusedElement = ref
      this.focusedElementDetailes = {
        orderId: id,
        prtId: prtId,
        field: field
      }
    },
    isInFocusElement (ref) {
      if (ref === this.focusedElement) {
        return true
      }
      return false
    },
    onBlur (part, field, shouldSave = true) {
      if (shouldSave && this.focusedElementDetailes) {
        let updatedOrder = _.findIndex(this.manualOrdersDataOriginal, order => {
          return Number(order.id) === Number(this.focusedElementDetailes.orderId)
        })
        if (updatedOrder !== -1) {
          let updatedPrt = _.find(this.manualOrdersDataOriginal[updatedOrder].items || [], prt => {
            return Number(prt.id) === Number(this.focusedElementDetailes.prtId)
          })
          let selectedF = this.focusedElementDetailes.field;
          if (updatedPrt && updatedPrt[selectedF] !== part[selectedF]) {
            this.saveOrderPart(this.focusedElementDetailes.orderId, part)
          }
        }
      }

      this.focusedElement = ''
      this.focusedElementDetailes = null
    },
  }
}
</script>

<style>
.orders-input-context {
  border: 1px solid buttonface;
  padding: 2px 7px;
  margin: 7px;
  width: 90%;
  height: 32px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}
.orders-input-context:focus {
  outline: 1px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.25rem rgba(94, 121, 255, 0.25);
}

.hasSubContextOrders{
  position: relative;
  padding-right: 5px !important;
}

.hasSubContextOrders:hover .orders-sub-context {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

.order-context-invoice-nbr {
  padding: 8px 25px 5px 10px !important;
  height: 31px;
}
.orders-sub-context {
  height: auto;
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;

  position: absolute;
  left: calc(100% + 1px);
  background: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
  0 1px 5px 0 rgba(0, 0, 0, 0.12);
  min-width: 100%;
  width: auto;

  top: 0;
  transition: 0.4s;
  visibility: hidden;
  opacity: 0;
  right: auto;
  transform: translateY(-10px);
}
.V3 .auth-estimate-multiselect .multiselect__tags {
  min-width: 50px !important;
}
.V3 .auth-estimate-multiselect .multiselect__input {
  min-width: 0px !important;
}
</style>

<style scoped>
.orders-table-body-row:hover{
  background-color: rgba(93, 84, 239, 0.08);
}
.context-active-row{
  background-color: rgba(93, 84, 239, 0.08);
}
.scanner-items{
  margin-left: 0px;
  width: 100%;
  position: absolute;
}
.datepicker-position-absolute{

}
.upload-bill-modal >>> .modal-lg{
  max-width: 450px;
}
.upload-bill-modal >>> .modal-body{
  text-align: center;
}

.upload-bill-modal >>> .modal-footer {
  display: none;
}
.xero{
  display: inline-block;
  height: 21px;
  width: 21px;
  margin-right: 5px;
}
.part-ps-logo{
  display: inline-block;
  height: 21px;
  width: 21px;
  margin-right: 5px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(~@/assets/icon/ps-icon.svg)
}
.checkbox-icon{
  margin-right: 5px !important;
  margin-left: 5px;
}
@media screen and (max-width: 767px) {
  .tab-header-orders{
    margin: 10px 10px 0;
  }
}
.tab-header-orders.active {
  background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
  color: #f8f8f8;
}

.tab-header-orders {
  border: 1px solid rgb(94, 121, 255);
  color: rgb(94, 121, 255);
  font-weight: bold;
}
.text-warning {
  color: #F59345 !important;
}
.text-success {
  color: #43B968 !important;
}
.incorrect-part-ordered-icon {
  color: red !important;
}
.gray-icon {
  color: rgb(121,121,121) !important
}
.processing-icon-orange {
  color: orange !important;
}

.bxs-truck.text-primary {
  color: #43B968 !important;
}

.orders-table-body-row{
  width: 100%;
  border-bottom: 1px solid rgba(27, 30, 56, .25);
  text-size-adjust: 100%;
  font-family: "Nunito Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 16px;
  tab-size: 4;
  text-indent: 0px;
  vertical-align: top;
  word-break: normal;
  display: flex;
  align-items: center;
}
.orders-table-body{
  /*border-bottom: 1px solid rgba(27, 30, 56, .25);*/
  width: 100%;
  min-width: 1560px;
  text-size-adjust: 100%;
  font-family: "Nunito Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 16px;
  tab-size: 4;
  text-indent: 0px;
  vertical-align: top;
  word-break: normal;
}
.orders-table-body-row-item{
  width: 100%;
  padding: .75rem .30rem;
  height: 45.5px;
  flex-grow: 1;
  text-size-adjust: 100%;
  font-family: "Nunito Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 16px;
  tab-size: 4;
  text-indent: 0px;
  vertical-align: top;
  word-break: normal;
  display: flex;
  align-items: center;
}
.orders-table-body-row-item:nth-child(1){
  max-width: 45px;
  min-width: 45px;
}
.orders-table-header-row-part-description,
.orders-table-body-row-part-description{
  min-width: 150px;
  flex-grow: 1;
}
.orders-table-header-row-part-number, .orders-table-body-row-part-number,
.orders-table-header-row-invoice-nbr, .orders-table-body-row-invoice-nbr,
.orders-table-header-row-invoice-date{
  min-width: 125px;
  max-width: 125px;
}
.orders-table-header-row-qty-ord, .orders-table-header-row-qty-rcvd,
.orders-table-body-row-qty-ord, .orders-table-body-row-qty-rcvd{
  max-width: 60px;
  min-width: 60px;
}
.orders-table-body-row-qty-ord, .orders-table-body-row-qty-rcvd{
  text-align: center;
}
.orders-table-header-row-qty-ord, .orders-table-header-row-qty-rcvd{
  text-align: left;
}
.orders-table-header-row-auth, .orders-table-body-row-auth{
  max-width: 45px;
  min-width: 45px;
}
.orders-table-header-row-total, .orders-table-header-row-list,
.orders-table-header-row-cost-price, .orders-table-body-row-total,
.orders-table-body-row-list, .orders-table-body-row-cost-price{
  max-width: 125px;
  min-width: 125px;
}
.orders-table-body-row-list, .orders-table-body-row-cost-price, .orders-table-body-row-total{
  justify-content: flex-end;
}
.orders-table-body-row-list input,
.orders-table-body-row-cost-price input{
  text-align: right;
}
.orders-table-header-row-list, .orders-table-header-row-cost-price, .orders-table-header-row-total{
  text-align: right;
  padding-right: 20px !important;
}
.orders-table-header-row-invoice-nbr {
  text-align: left;
}
.orders-table-header-row-type-type, .orders-table-body-row-type-type{
  max-width: 125px;
  min-width: 125px;
}
.orders-table-header-row-status, .orders-table-body-row-status{
  max-width: 165px;
  min-width: 165px;
}
.orders-table-body-row-icon,
.orders-table-header-row-icon{
  min-width: 160px;
  max-width: 160px;
}
.orders-table-body-row-type >>> .multiselect__placeholder,
.orders-table-body-row-status >>> .multiselect__placeholder{
  display: none;
}
.orders-table-header{
  min-width: 1560px;
  width: 100%;
  background-color: #e1e2e5;
  font-size: 13px;
  font-weight: 700;
  flex-grow: 1;
  text-size-adjust: 100%;
  font-family: "Nunito Sans", sans-serif;
  letter-spacing: normal;
  line-height: 16px;
  tab-size: 4;
  text-indent: 0px;
  vertical-align: top;
  word-break: normal;
}
.orders-table-header-item:nth-child(1){
  max-width: 45px;
  min-width: 45px;
}
.orders-table-header-item{
  width: 100%;
  padding: .75rem .30rem;
  text-size-adjust: 100%;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: normal;
  line-height: 16px;
  tab-size: 4;
  text-indent: 0px;
  vertical-align: top;
  word-break: normal;
  height: 42px;
}
.orders-body{
  margin: 15px;
  width: calc(100% - 30px);
}
.orders-summary{
  width: 20%;
}
.orders-section{
  width: 100%;
  margin-left: 0;
}
.orders-table-body-row-type >>> .multiselect__tags,
.orders-table-body-row-status >>> .multiselect__tags{
  height: 32px;
  overflow: visible !important;
  padding-right: 30px;
}
.orders-table-body-row-type >>> .multiselect__content-wrapper,
.orders-table-body-row-status >>> .multiselect__content-wrapper{
  max-height: none !important;
  overflow: visible !important;
}
.orders-table-body-row-type >>> .multiselect__input,
.orders-table-body-row-status >>> .multiselect__input{
  min-width: 75px;
}
.orders-table-body-row-type >>> .multiselect__single,
.orders-table-body-row-status >>> .multiselect__single{
  padding-right: 22px;
}
.orders-table-body-row-type >>> .multiselect__select,
.orders-table-body-row-status >>> .multiselect__select{
  right: 0 !important;
  width: 28px;
  z-index: 2;
}
.orders-table-body-row{
  position: relative;
}
.orders-table-body-row:focus-within{
  z-index: 1010;
}
.orders-table-body-row-type >>> .multiselect--active,
.orders-table-body-row-status >>> .multiselect--active{
  z-index: 1020;
}
.orders-table-body-row-type >>> .multiselect--active .multiselect__content-wrapper,
.orders-table-body-row-status >>> .multiselect--active .multiselect__content-wrapper{
  z-index: 1030;
}
.orders-header{
  line-height: normal;
  font-size: 14px;
  font-weight: 700;
  background-color: #D1D5DB;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  padding: 10px 15px;
  min-height: 48px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.orders-header-left{
  display: flex;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}
.orders-header-mobile .orders-header-left,
.orders-header-mobile .orders-global-stats{
  flex-wrap: nowrap;
}
.orders-header-mobile .orders-header-left{
  width: 100%;
}
.orders-header-mobile .orders-global-stats{
  width: 100%;
  justify-content: space-between;
}
.orders-header-left > span{
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 18px;
}
.orders-header-mobile .orders-global-stats-title-mobile{
  display: block;
}
.orders-header-mobile .orders-header-left > span{
  margin-right: 40px;
}
.orders-global-stats-block-mobile{
  display: block;
}
.orders-global-stats{
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.orders-profit-text{
  color: #047857;
  font-weight: 700;
}
.orders-controls{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 12px;
}
.orders-part-search{
  position: relative;
  flex: 1;
  min-width: 220px;
  max-width: 400px;
}
.orders-part-search .bx{
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6B7280;
  font-size: 14px;
}
.orders-part-search input{
  width: 100%;
  height: 32px;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  padding: 7px 12px 7px 32px;
  outline: none;
  transition: border-color 0.2s;
}
.orders-part-search input:hover,
.orders-part-search input:focus{
  border-color: #5D54EF;
}
.orders-filter-group{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.orders-filter-btn{
  background-color: #5D54EF;
  border: 1px solid #5D54EF;
  color: #FFFFFF;
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  height: 28px;
}
.orders-filter-btn:hover{
  background-color: #4A43CC;
  border-color: #4A43CC;
}
.orders-filter-btn.active{
  background-color: #1E3A8A;
  border-color: #1E3A8A;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}
.orders-filter-all{
  background-color: #1E3A8A;
  border-color: #1E3A8A;
}
.orders-filter-all:hover{
  background-color: #1E3A8A;
  border-color: #1E3A8A;
}
.orders-outline-btn{
  border: 1px solid #5D54EF;
  color: #5D54EF;
  background: #FFFFFF;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  font-weight: 600;
  white-space: nowrap;
}
.orders-outline-btn:hover{
  border-color: #4A43CC;
  color: #4A43CC;
  background-color: #EEF2FF;
}
.orders-outline-btn .orders-outline-btn-mobile-hide{
  display: none;
}
.orders-outline-btn-mobile{
  position: absolute;
  top: 10px;
  right: 10px;
  height: 33.5px;
}
.orders-filter-btn .orders-outline-btn-mobile-hide {
  display: none;
}
.orders-filter-btn.orders-outline-btn-mobile {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 33.5px;
}
.orders-scan-btn{
  color: #111827;
  border-color: #111827;
}
.orders-scan-btn:hover{
  color: #111827;
  border-color: #111827;
  background-color: #F3F4F6;
}
.orders-summary-info{
  margin: 15px 10px;
}
.orders-summary-info-item{
  margin-bottom: 15px;
}
.orders-summary-info-item-name{
  margin-right: 15px;
}
.orders-summary-info-item-user{
  font-weight: bold;
  word-spacing: 8px;
}
.orders-summary-using{
  margin-top: 40px;
}
.orders-section-item-header-elem_name{
  display: flex;
  align-items: center;
  margin-right: 5px;
  font-weight: 700;
  color: #000000;
}
.orders-section-item-header-elem_info{
  font-weight: 900;
  color: #000000;
}
.orders-section-item-header{
  margin: 0;
  padding: 12px 15px;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  background-color: #D1D5DB;
  border-bottom: 1px solid #D1D5DB;
  cursor: pointer;
  color: #000000;
  transition: filter 0.2s;
}
.orders-section-item-header:hover{
  filter: brightness(0.97);
}
.orders-section-body.open .orders-section-item-header{
  background-color: #FFFFFF;
}
.orders-section-item-header-elem{
  margin-right: 15px;
}
.orders-section-item-header-info{
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 0;
}
.orders-section-item-header-actions{
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: auto;
}
.orders-order-stats{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.3;
  color: #000000;
  white-space: nowrap;
}
.orders-accordion-chevron{
  color: #000000;
  transition: transform 0.3s ease;
  font-size: 24px!important;
}
.orders-section-body.open .orders-accordion-chevron{
  transform: rotate(180deg);
}

.orders-section-body{
  padding-bottom: 0;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 15px;
  overflow: visible;
  background-color: #FFFFFF;
}
.orders-section-body.open{
  position: relative;
  z-index: 100;
}
.orders-section-body:focus-within{
  position: relative;
  z-index: 1000;
}
.orders-section-body:focus-within >>> .vc-popover-content-wrapper{
  z-index: 1040 !important;
}
.orders-section-item-header{
  position: relative;
  z-index: 50;
}
.orders-section-item-header .multiselect{
  position: relative;
  width: 160px;
  min-width: 160px;
  z-index: 60;
}
.orders-section-item-header >>> .multiselect__content-wrapper{
  width: 160px;
  min-width: 160px;
  z-index: 70;
}
.orders-section-item-header-elem-supplier >>> .multiselect__content-wrapper{
  width: 200px;
  min-width: 200px;
  z-index: 70;
}
.orders-section-body:last-child{
  border-bottom: 1px solid #D1D5DB;
}
.orders-table-body div{
  font-size: 13px;
  font-weight: 600;
}
.orders-table-body .orders-table-body-row-part-description{
  font-weight: 800;
}
.orders-table-body .bx{
  font-size: 24px;
  margin-right: 5px;
}
.orders-table-body .bx-exit,
.orders-table-body .bx-edit-alt {
  color: #2e6ba3;
}
.orders-table-body .bx-chat.bx-chat-yellow{
  color: #d59800;
}
.orders-table-body .bx-trash{
  color: red;
}
.orders-table-body .bx-chat.bx-chat-grey{
  color: #a5a3a3;
}
.orders-table-body .bx-dollar-circle.bx-dollar-circle-green{
  color: #4b8723;
}
.orders-table-body .bx-dollar-circle.bx-dollar-circle-grey{
  color: #a5a3a3;
}
.orders-icons-tooltip {
  left: -10px !important;
}
.orders-pdf-viewer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background: #fff;
}
.orders-summary-add-manual-order{
  margin-top: 40px;
}

.tab-header-orders.active{
  background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
  color: #f8f8f8;
}
.tab-header-orders{
  border: 1px solid rgb(94, 121, 255);
  color: rgb(94, 121, 255);
  font-weight: bold;
}
@media screen and (max-width: 1824px) {
  .table-orders{
    padding-bottom: 0;
    overflow-x: auto;
    scrollbar-width: thin;
    height: auto;
  }
  /*.orders-table-body >>> .multiselect .multiselect__content-wrapper{
    overflow-y: auto !important;
  }
  .orders-table-body .orders-table-body-row-type-type >>> .multiselect .multiselect__content-wrapper{
    min-width: calc(125px - .60rem);
  }*/
}

.orders-add-part-row {
  padding: 15px;
  min-width: 1560px;
  background-color: #FFFFFF;
}

@media screen and (max-width: 900px) {
  .orders-header{
    align-items: flex-start;
    flex-direction: column;
  }
  .orders-header-left{
    align-items: flex-start;
    gap: 8px;
  }
  .orders-global-stats{
    gap: 8px;
  }
  .orders-controls{
    align-items: stretch;
    flex-direction: column;
  }
  .orders-part-search{
    max-width: 100%;
  }
  .orders-filter-group{
    justify-content: space-between;
  }
  .orders-filter-btn{
    flex: 1;
    text-align: center;
  }
  .orders-section-item-header{
    align-items: flex-start;
    flex-direction: column;
  }
  .orders-section-item-header-info{
    align-items: flex-start;
    flex-direction: column;
  }
  .orders-section-item-header-actions{
    justify-content: space-between;
    margin-left: 0;
    width: 100%;
  }
  .orders-order-stats{
    align-items: flex-start;
  }
}

</style>
